<template>
	<div class="v2-forms">
		<div
			v-if="current_view == 'LIST'"
			style="margin-top: 20px; padding: 0px 0px"
		>
			<el-row :gutter="5">
				<el-col :span="5">
					<el-input
					type="text"
					v-model="search"
					placeholder="Search Forms"
					suffix-icon="el-icon-search"
					class="input-class"
				/>
				</el-col>
				<el-col style="margin-top: -40px" :span="3" :offset="16">
					<el-button
						@click="show_actions"
						class="button-class"
						icon="el-icon-circle-plus-outline"
						style="max-width: 100%"
					>
						Add Form
					</el-button>
				</el-col>
			</el-row>
			<el-row style="margin-top: 20px" class="">
				<el-col v-if="computedFormsList.length == 0" :span="24">
					<el-card v-loading="isloading" :style="height">
						<div style="text-align: center; margin-top: 100px">
							<img src="../../../assets/images/Union.png" />
						</div>
						<div style="text-align: center; font-weight: 200">
							There is nothing to show you right now
						</div>
					</el-card>
				</el-col>
				<el-col v-else :span="24">
					<el-row
						v-loading="isloading"
						class="form-lists"
						style="margin-top: 10px; border-radius: 12px"
					>
						<el-col :span="24">
							<el-table
								style="border-radius: 8px"
								ref="multipleTable"
								:data="
									computedFormsList.filter(
										(el, index) => index >= startNumber - 1 && index < endNumber
									)
								"
							>
								<el-table-column width="300px" label="Form">
									<template slot="header" slot-scope="scope">
										Form
										<el-popover placement="right" trigger="click">
											<el-input
												v-model="searched_form_name"
												size="mini"
												placeholder="Search Form"
											></el-input>
											<div
												style="
													max-height: 250px;
													overflow: auto;
													margin-top: 10px;
												"
											>
												<el-checkbox-group v-model="selected_form">
													<el-checkbox
														v-for="(formItem, index) in uniqueFormNames.filter(
															(el) =>
																!searched_form_name ||
																el
																	.toLowerCase()
																	.includes(searched_form_name.toLowerCase())
														)"
														:key="index"
														class="mb-2 checkbox-lable"
														:label="formItem"
														style="display: block"
													></el-checkbox>
												</el-checkbox-group>
											</div>
											<div
												style="text-align: center"
												v-if="
													uniqueFormNames.filter(
														(el) =>
															!searched_form_name ||
															el
																.toLowerCase()
																.includes(searched_form_name.toLowerCase())
													).length == 0
												"
											>
												No results found
											</div>
											<div class="flex justify-between mt-4">
												<span
													class="text-xs cursor-pointer primary-theme-color"
													@click="selected_form = [...uniqueFormNames]"
													>Select all</span
												>
												<span
													class="text-xs cursor-pointer"
													@click="selected_form = []"
													>Reset</span
												>
											</div>
											<span slot="reference">
												<img
													v-if="selected_form.length"
													src="../../../assets/images/filter.png"
													width="9"
													class="cursor-pointer"
												/>
												<img
													v-else
													src="../../../assets/images/filterBlack.png"
													width="9"
													class="cursor-pointer"
												/>
											</span>
										</el-popover>
									</template>
									<template slot-scope="scope">
										<div
											@click="toggle_actions(scope.$index, scope.row, 'EDIT')"
											style="
												margin-top: -5px;
												color: #d26300;
												cursor: pointer;
												word-break: break-word;
											"
										>
											<u>{{ scope.row.name }}</u>
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="category" label="Category">
									<template slot="header" slot-scope="scope">
										Category
										<el-popover placement="right" trigger="click">
											<el-input
												v-model="searched_category_name"
												size="mini"
												placeholder="Search Category"
											></el-input>
											<div
												style="
													max-height: 250px;
													overflow: auto;
													margin-top: 10px;
												"
											>
												<el-checkbox-group v-model="selected_category">
													<el-checkbox
														v-for="(
															formItem, index
														) in uniqueCategoryNames.filter(
															(el) =>
																!searched_category_name ||
																el
																	.toLowerCase()
																	.includes(
																		searched_category_name.toLowerCase()
																	)
														)"
														:key="index"
														class="mb-2 checkbox-lable"
														:label="formItem"
														style="display: block"
													></el-checkbox>
												</el-checkbox-group>
											</div>
											<div
												style="text-align: center"
												v-if="
													uniqueCategoryNames.filter(
														(el) =>
															!searched_category_name ||
															el
																.toLowerCase()
																.includes(searched_category_name.toLowerCase())
													).length == 0
												"
											>
												No results found
											</div>
											<div class="flex justify-between mt-4">
												<span
													class="text-xs cursor-pointer primary-theme-color"
													@click="selected_category = [...uniqueCategoryNames]"
													>Select all</span
												>
												<span
													class="text-xs cursor-pointer"
													@click="selected_category = []"
													>Reset</span
												>
											</div>
											<span slot="reference">
												<img
													v-if="selected_category.length"
													src="../../../assets/images/filter.png"
													width="9"
													class="cursor-pointer"
												/>
												<img
													v-else
													src="../../../assets/images/filterBlack.png"
													width="9"
													class="cursor-pointer"
												/>
											</span>
										</el-popover>
									</template>
									<template slot-scope="scope">
										<div style="word-break: break-word">
											{{ scope.row.category }}
										</div>
									</template>
								</el-table-column>
								<el-table-column label="Scoring Type">
									<template slot-scope="scope">
										{{
											scope.row.scoring_type == "by_steps"
												? "Score for each step"
												: scope.row.scoring_type == "all_pass"
												? "Score for overall form"
												: "Not Applicable"
										}}
									</template>
								</el-table-column>
								<el-table-column prop="total_points" label="Total Points">
								</el-table-column>
								<el-table-column label="Created By">
									<template slot-scope="scope">
										{{
											scope.row.created_by_info != null
												? scope.row.created_by_info.full_name != undefined
													? scope.row.created_by_info.full_name
													: "-"
												: "-"
										}}
									</template>
								</el-table-column>
								<el-table-column label="Created On">
									<template slot-scope="scope">
										{{
											scope.row.created_at != null
												? moment
														.utc(scope.row.created_at)
														.local()
														.format("Do MMM YYYY, h:mm a")
												: "-"
										}}
									</template>
								</el-table-column>
								<el-table-column width="100px" show-overflow-tooltip>
									<template slot-scope="scope">
										<img
											@click="toggle_actions(scope.$index, scope.row, 'EDIT')"
											width="15px"
											class="mr-5"
											src="../../../assets/icons/EditIcon.png"
											style="cursor: pointer"
										/>
										<img
											@click="toggle_actions(scope.$index, scope.row, 'DELETE')"
											width="13px"
											style="cursor: pointer"
											src="../../../assets/icons/Union.png"
										/>
									</template>
								</el-table-column>
							</el-table>
						</el-col>
					</el-row>
					<el-row :gutter="10" class="mt-3">
						<el-col :span="8" class="text-left">
							<div>
								<b>Showing</b> {{ startNumber }} to {{ endNumber }} of
								{{ computedFormsList.length }} results
							</div>
						</el-col>
						<el-col :span="8" class="text-center">
							<el-select
								v-model="perPage"
								name="per_page"
								placeholder="select per page"
								style="width: 90px !important"
								size="mini"
							>
								<el-option label="10" :value="10"></el-option>
								<el-option label="25" :value="25"></el-option>
								<el-option label="50" :value="50"></el-option>
								<el-option label="100" :value="100"></el-option>
							</el-select>
							&nbsp;<b>per page</b>
						</el-col>
						<el-col :span="8" class="text-right">
							<el-pagination
								background
								layout="prev, pager, next"
								:total="computedFormsList.length"
								:page-size="perPage"
								:current-page.sync="currentPage"
							></el-pagination>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
		</div>
		<div v-if="current_view == 'ADD' && step == 1">
			<el-row style="margin-top: -3px; margin-bottom: 0px">
				<el-col :span="1">
					<img
						@click="get_list_forms()"
						width="35px"
						src="../../../assets/icons/Back Arrow.png"
						style="cursor: pointer"
					/>
				</el-col>
				<el-col
					style="
						margin-top: 0px;
						color: #999999;
						margin-left: -10px;
						font-size: 16px;
					"
					:span="10"
				>
					<div @click="get_list_forms()">Back</div>
				</el-col>
			</el-row>
		</div>
		<div
			v-if="current_view == 'ADD' || current_view == 'EDIT'"
			style="padding: 0px 0px"
		>
			<el-card
				style="padding-left: 50px"
				v-if="tabItems[0].active"
				shadow="never"
			>
				<h3 v-if="step == 1">New Form</h3>
				<div
					v-if="step == 1"
					style="font-weight: 200px; font-size: 10px; margin-top: 5px"
				>
					Provide information and create a form template
				</div>
				<div v-if="step != 1 && formEditable == false">
					<!-- <div>
						<h3>
							{{ title }}
						
						</h3>
					</div>
					<div class="mt-2" style="font-size: 12px">{{ category }}</div> -->
					<el-row>
						<el-col :span="5"> Form </el-col>
						<el-col :span="5" :offset="1"> Category </el-col>
						<el-col :span="5" :offset="1"> Scoring Type </el-col>
						<el-col
							v-if="scoringType == 'Score for overall form'"
							:offset="1"
							:span="6"
						>
							Expected Response
						</el-col>
						<!-- <el-col :span="2"> Critical </el-col> -->
					</el-row>
					<el-row>
						<el-col :span="5">
							<h3 style="word-break: break-word; line-height: 120%">
								{{ title }}
							</h3>
						</el-col>
						<el-col :offset="1" :span="5">
							<h3 style="word-break: break-word; line-height: 120%">
								{{ category }}
							</h3>
						</el-col>
						<el-col :offset="1" :span="5">
							<h3 style="word-break: break-word; line-height: 120%">
								{{ scoringType }}
							</h3>
						</el-col>
						<el-col
							:offset="1"
							v-if="scoringType == 'Score for overall form'"
							:span="6"
						>
							<h3 style="word-break: break-word; line-height: 120%">
								{{ yes_value }} : {{ yes_value_points }} , {{ no_value }} :
								{{ no_value_points }}
							</h3>
							<!-- <h3 style="word-break: break-word; line-height: 120%">
								{{ no_value }} : {{ no_value_points }}
							</h3> -->
						</el-col>
						<!-- <el-col :span="2">
							<h3 style="word-break: break-word; line-height: 120%">
								{{ is_critical == true ? "Yes" : "No" }}
							</h3>
						</el-col> -->
						<el-col :span="1">
							<img
								width="15px"
								class="ml-1"
								src="../../../assets/icons/EditIcon.png"
								@click="formEditable = true"
								style="cursor: pointer"
							/>
						</el-col>
					</el-row>
				</div>
				<div
					v-if="step == 1 || formEditable == true"
					:style="formEditable ? '' : 'margin-top: 20px'"
				>
					<el-row :gutter="5">
						<el-col :span="8">
							<label style="font-size: 14px">Form Title</label>
							<el-input
								type="text"
								v-model="title"
								placeholder="Enter form title"
								class="input-class mt-2"
								v-validate="'required'"
								name="form title"
							/>
							<p>
								<span
									:v-show="errors.has(`form title`)"
									class="text-red-dark text-xs"
								>
									{{
										errors.first(`form title`) ? "This field is required" : ""
									}}
								</span>
							</p>
						</el-col>
						<el-col :span="6" :offset="1">
							<label style="font-size: 14px">Form Category</label>
							<el-select
								@change="sellect_current_category(category)"
								style="margin-top: 7px"
								class="select"
								v-model="category"
								filterable
								placeholder="Select Category"
								clearable
								v-validate="'required'"
								name="Select Category"
							>
								<el-option value="">
									<div
										@click="add_edit_category('ADD', null)"
										style="color: #d26300; font-weight: 600"
									>
										Add New Category
									</div>
								</el-option>
								<el-option
									v-for="(item, idx) in category_items"
									:key="idx"
									:value="item.name"
								>
									<el-row :gutter="3">
										<el-col :span="24">
											{{ item.name }}
										</el-col>
										<!-- <el-col :span="2">
											<img
												@click="add_edit_category('EDIT', item)"
												width="15px"
												class="mr-5"
												src="../../../assets/icons/EditIcon.png"
											/>
										</el-col>
										<el-col style="margin-top: -1px" :span="2">
											<img
												@click="delete_category(item)"
												width="13px"
												src="../../../assets/icons/Union.png"
											/>
										</el-col> -->
									</el-row>
								</el-option>
							</el-select>
							<p>
								<span
									:v-show="errors.has(`Select Category`)"
									class="text-red-dark text-xs"
								>
									{{
										errors.first(`Select Category`)
											? "This field is required"
											: ""
									}}
								</span>
							</p>
						</el-col>
						<el-col :span="5" :offset="1">
							<label style="font-size: 14px">Scoring Type</label>
							<el-select
								@change="sellect_current_scoringType(scoringType)"
								style="margin-top: 7px"
								class="select"
								v-model="scoringType"
								filterable
								placeholder="Select Scoring Type"
								v-validate="'required'"
								name="Select Scoring Type"
							>
								<el-option
									v-for="(item, idx) in scoringType_items"
									:key="idx"
									:value="item.name"
									:label="item.name"
								>
								</el-option>
							</el-select>
							<p>
								<span
									:v-show="errors.has(`Select Scoring Type`)"
									class="text-red-dark text-xs"
								>
									{{
										errors.first(`Select Scoring Type`)
											? "This field is required"
											: ""
									}}
								</span>
							</p>
						</el-col>
					</el-row>
					<el-row
						v-if="scoringType == 'Score for overall form'"
						style="margin-top: 20px"
					>
						<el-col style="margin-top: 10px" :span="3">
							<div>Expected Response</div>
						</el-col>
						<el-col :span="3">
							<el-select
								style="margin-top: 10px; font-size: 12px"
								class="select"
								v-model="yes_value"
								placeholder="Select"
							>
								<el-option
									v-for="(item, idx) in yes_value_items"
									:key="idx"
									:value="item.name"
									:label="item.name"
								>
								</el-option>
							</el-select>
						</el-col>
						<el-col :span="2" style="margin-left: 10px">
							<el-select
								style="margin-top: 10px"
								class="select"
								v-model="pos_neg"
								placeholder="Select "
								v-validate="'required'"
								name="Select"
							>
								<el-option
									v-for="(item, idx) in pos_neg_items"
									:key="idx"
									:value="item.value"
									:label="item.name"
								>
								</el-option>
							</el-select>
						</el-col>
						<el-col style="margin-left: 10px; margin-top: 10px" :span="1">
							<div>Points</div>
						</el-col>
						<el-col
							:style="errors.has(`Points `) ? 'margin-top:30px' : ''"
							:span="2"
						>
							<el-select
								style="margin-top: 10px; font-size: 12px"
								class="select"
								v-model="yes_value_points"
								placeholder="Select"
								v-validate="'required'"
								:name="`Points `"
								:disabled="!pos_neg"
								:filterable="true"
							>
								<el-option
									v-for="(item, idx) in yes_no_value_points_items"
									:key="idx"
									:value="item.name"
									:label="item.name"
								>
								</el-option>
							</el-select>
							<p>
								<span
									:v-show="errors.has(`Points `)"
									class="text-red-dark text-xs"
								>
									{{ errors.first(`Points `) ? "This field is required" : "" }}
								</span>
							</p>
						</el-col>
						<el-col :span="3" :offset="1">
							<el-select
								style="margin-top: 10px"
								class="select"
								v-model="no_value"
								placeholder="Select"
							>
								<el-option
									v-for="(item, idx) in yes_value_items"
									:key="idx"
									:value="item.name"
									:label="item.name"
								>
								</el-option>
							</el-select>
						</el-col>
						<el-col :span="2" style="margin-left: 10px">
							<el-select
								style="margin-top: 10px"
								class="select"
								v-model="pos_neg_2"
								placeholder="Select "
								v-validate="'required'"
								name="Select"
							>
								<el-option
									v-for="(item, idx) in pos_neg_items"
									:key="idx"
									:value="item.value"
									:label="item.name"
								>
								</el-option>
							</el-select>
						</el-col>
						<el-col style="margin-left: 10px; margin-top: 10px" :span="1">
							<div>Points</div></el-col
						>
						<el-col
							:style="errors.has('Points') ? 'margin-top:30px' : ''"
							:span="2"
						>
							<el-select
								style="margin-top: 10px"
								class="select"
								v-model="no_value_points"
								placeholder="Select"
								v-validate="'required'"
								name="Points"
								:filterable="true"
								:disabled="!pos_neg_2"
							>
								<el-option
									v-for="(item, idx) in yes_no_value_points_items"
									:key="idx"
									:value="item.name"
									:label="item.name"
								>
								</el-option>
							</el-select>
							<p>
								<span
									:v-show="errors.has(`Points`)"
									class="text-red-dark text-xs"
								>
									{{ errors.first(`Points`) ? "This field is required" : "" }}
								</span>
							</p>
						</el-col>
					</el-row>
					<el-row style="margin-top: 20px">
						<!-- <el-col :span="3">
							<div>Mark Critical</div>
						</el-col>
						<el-col :span="2">
							<el-switch
								v-model="markCritical"
								:active-text="markCritical ? '(Yes)' : '(No)'"
								active-color="#41BE62"
							>
							</el-switch>
						</el-col>
						<el-col :span="13">
							<div style="font-size: 10px; margin-top: 5px; margin-left: 10px">
								If enabled, total points for the category will be marked as zero
								if expected response for this form Fails
							</div>
						</el-col> -->
						<el-col :span="2" :offset="18" v-if="formEditable == true">
							<el-button
								@click="formEditable = false"
								class="button-class-white2"
								style="border: none"
							>
								Cancel
							</el-button>
						</el-col>
						<el-col
							style="margin-bottom: 40px"
							:span="2"
							v-if="formEditable == true"
						>
							<el-button @click="edit_form_api()" class="button-class">
								Save
							</el-button>
						</el-col>
					</el-row>
				</div>
			</el-card>
			<el-row
				v-if="formEditable == false"
				style="padding-left: 70px"
				:style="tabItems[0].active ? 'margin-top: 30px' : 'margin-top: 0px'"
			>
				<el-col
					v-if="current_view == 'ADD'"
					v-for="(item, idx) in tabItems"
					:key="idx"
					:span="3"
				>
					<div :style="item.active ? 'font-weight:bold' : ''">
						{{ item.name }}
					</div>
				</el-col>
				<el-col v-if="current_view == 'EDIT'">
					<div style="font-weight: bold">
						{{ tabItems[0].name }}
					</div>
				</el-col>
			</el-row>
			<el-row
				v-if="tabItems[0].active && formEditable == false"
				style="margin-top: 10px"
			>
				<el-col :span="24">
					<div v-if="step == 1">
						<el-card style="padding-left: 50px" shadow="never">
							<div
								style="overflow-y: auto; overflow-x: hidden"
								:style="
									scoringType == 'Score for overall form'
										? 'min-height: 35vh;max-height: 35vh'
										: 'min-height: 43vh;max-height: 43vh'
								"
							>
								<el-button
									class="button-class-white"
									style="margin-top: 30px"
									icon="el-icon-plus"
									@click="proceed_further(2)"
								>
									Add New Section
								</el-button>
								<div
									style="margin-top: 15px; font-weight: 100; font-size: 14px"
								>
									You can create sections and group steps into multiple sections
								</div>
								<div style="margin-top: 25px">OR</div>
								<el-button
									class="button-class-white"
									style="margin-top: 20px"
									icon="el-icon-plus"
									@click="proceed_further(4)"
								>
									Add Step
								</el-button>
								<div
									style="margin-top: 15px; font-weight: 100; font-size: 14px"
								>
									Add steps without adding section
								</div>
							</div>
							<!-- <el-row style="margin-bottom: 10px">
								<el-col :span="3" :offset="17">
									<el-button
										class="button-class-white-dialog"
										@click="get_list_forms()"
									>
										Exit
									</el-button>
								</el-col>
							</el-row> -->
						</el-card>
					</div>
					<div v-if="step == 2">
						<el-card style="padding-left: 50px" shadow="never">
							<div
								style="
									min-height: 56vh;
									max-height: 56vh;
									overflow-y: auto;
									overflow-x: hidden;
								"
								id="scrollableCard"
							>
								<div v-if="current_selection == 'Section'">
									<el-button
										class="button-class-white2"
										style="margin-top: 20px"
										icon="el-icon-plus"
										@click="addNewSection(1)"
									>
										Add New Section
									</el-button>
								</div>
								<div
									v-for="(itemx, idx) in sectionItems"
									:key="idx"
									:gutter="5"
								>
									<el-row
										v-if="current_selection == 'Section'"
										style="margin-top: 20px"
									>
										<el-col :span="1">
											<h4>{{ idx + 1 }}.</h4>
										</el-col>
										<el-col v-if="itemx.editable" :span="6">
											<el-input
												type="text"
												v-model="itemx.name"
												placeholder="Enter section name"
												class="input-class"
												:minlength="1"
												:maxlength="99"
											/>
										</el-col>
										<el-col v-if="itemx.editable" :span="11" :offset="1">
											<el-button
												size="mini"
												class="button-class-white2"
												style="height: 30px"
												@click="addStep(idx, itemx)"
												:disabled="sectionLoading"
												>Save</el-button
											>
											<el-button
												@click="delete_section_row(itemx, idx)"
												icon="el-icon-delete"
												size="small"
												style="border: none; background-color: transparent"
											></el-button>
										</el-col>
										<el-col v-if="itemx.editable == false" :span="6">
											<span
												style="
													font-weight: 700;
													display: inline-block;
													max-width: 70%;
													overflow: hidden;
													text-overflow: ellipsis;
													white-space: nowrap;
												"
											>
												{{ itemx.name }}
											</span>

											<span>
												<el-button
													size="mini"
													style="border: none; background-color: transparent"
													@click="edit_section_row(itemx, idx)"
												>
													<img
														src="../../../assets/icons/edit_pencil_icon.png"
														width="10px"
														height="10px"
														alt=""
													/>
												</el-button>
												<el-button
													@click="delete_section_row(itemx, idx)"
													icon="el-icon-delete"
													size="small"
													style="border: none; background-color: transparent"
												></el-button>
											</span>
										</el-col>
										<el-col
											v-if="itemx.editable == false"
											:span="3"
											:offset="1"
										>
											<div>Mark all Yes/No</div>
										</el-col>
										<el-col v-if="itemx.editable == false" :span="2">
											<el-switch
												@change="edit_form_api"
												id="ns-sec-switch-01"
												v-model="show_mark_all_yes_no"
												:active-text="show_mark_all_yes_no ? '(Yes)' : '(No)'"
												:disabled="show_yes_no_boolean"
												active-color="#41BE62"
											>
											</el-switch>
										</el-col>
										<el-col
											v-if="itemx.editable == false"
											:span="2"
											:offset="1"
										>
											<div>Mark all NA</div>
										</el-col>
										<el-col v-if="itemx.editable == false" :span="2">
											<el-switch
												@change="edit_form_api"
												id="ns-sec-switch-02"
												v-model="show_mark_all_na"
												:active-text="show_mark_all_na ? '(Yes)' : '(No)'"
												active-color="#41BE62"
											>
											</el-switch>
										</el-col>
										<el-col
											style="margin-top: -5px"
											v-if="itemx.editable == false"
											:span="4"
											:offset="2"
										>
											<el-button
												class="button-class-white2"
												icon="el-icon-plus"
												@click="show_form_card(idx, itemx)"
											>
												Add Step
											</el-button>
										</el-col>
									</el-row>
									<el-row v-if="current_selection == 'Step'" class="my-5">
										<el-col :span="3" :offset="6">
											<div>Mark all Yes/No</div>
										</el-col>
										<el-col :span="2">
											<el-switch
												@change="edit_form_api"
												id="ns-sec-switch-03"
												v-model="show_mark_all_yes_no"
												:active-text="show_mark_all_yes_no ? '(Yes)' : '(No)'"
												:disabled="show_yes_no_boolean"
												active-color="#41BE62"
											>
											</el-switch>
										</el-col>
										<el-col :span="2" :offset="1">
											<div>Mark all NA</div>
										</el-col>
										<el-col :span="2">
											<el-switch
												@change="edit_form_api"
												id="ns-sec-switch-04"
												v-model="show_mark_all_na"
												:active-text="show_mark_all_na ? '(Yes)' : '(No)'"
												active-color="#41BE62"
											>
											</el-switch>
										</el-col>
										<el-col style="margin-bottom: 5px" :span="4" :offset="6">
											<el-button
												class="button-class-white2"
												icon="el-icon-plus"
												@click="show_form_card(idx, itemx)"
											>
												Add Step
											</el-button>
										</el-col>
									</el-row>
									<!-- <div
										v-if="
											current_selection == 'Section' &&
											itemx.form_questions_list
												? itemx.form_questions_list.length != 0
												: []
										"
										style="border: 1px dashed; border-color: #d3d3d3"
										class="my-5"
									></div> -->
									<div class="mb-3"></div>
									<el-row
										v-loading="isloading"
										v-for="(item, idx) in itemx.form_questions_list"
										:key="idx"
									>
										<el-col :span="22">
											<div
												style="
													border: 1px solid #f9a168;
													border-color: #f9a168;
													margin-bottom: 30px;
													border-radius: 5px;
												"
											>
												<el-card v-if="item.default == false" shadow="never">
													<el-row v-if="item.showDropdown">
														<el-col :span="20"
															><div style="color: #f9a168; font-size: 12px">
																Move to Location {{ item.serial_no }}
															</div></el-col
														>
													</el-row>
													<el-row>
														<el-col
															:span="2"
															:offset="item.showDropdown ? 0 : 1"
														>
															<div
																@mouseover="show_edit_icon(item)"
																@mouseleave="hide_edit_icon(item)"
																style="font-size: 14px"
																:style="
																	item.type == 'Checklist'
																		? 'margin-left: 0px'
																		: 'margin-left: 0px'
																"
															>
																<input
																	v-if="item.type == 'Checklist'"
																	type="checkbox"
																	:disabled="item.marked_as_na"
																	style="width: 17px; height: 17px"
																/>
																<b
																	v-if="!item.showDropdown"
																	@mouseleave="hide_edit_icon(item)"
																	:style="
																		item.type == 'Checklist'
																			? 'margin-left:10px'
																			: ''
																	"
																>
																	<!-- {{  itemx.form_questions_list.indexOf(item) }}. -->
																	{{ item.serial_no }}.
																	<img
																		@click="show_dropdown(item)"
																		v-if="item.editable_icon == true"
																		width="14px"
																		class="mr-5"
																		src="../../../assets/icons/EditIcon.png"
																	/>
																</b>
																<el-select
																	v-if="item.showDropdown"
																	style="margin-top: 10px; width: 100%"
																	class="select"
																	v-model="item.serial_no"
																	filterable
																	placeholder="Select Locations"
																	@visible-change="
																		change_serial_number(item, idx, $event)
																	"
																>
																	<el-option
																		v-for="(itemxx, key) in serialNumberItems"
																		:key="key"
																		:label="itemxx.name"
																		:value="itemxx.value"
																	>
																	</el-option>
																</el-select>
															</div>
														</el-col>
														<el-col
															class="ml-2 mt-1"
															v-if="item.showDropdown"
															:span="1"
														>
															<el-button
																@click="cancel_change_serial_number(item, idx)"
																size="mini"
																icon="el-icon-close"
																style="
																	border-radius: 12px;
																	color: red;
																	border-color: red;
																"
															></el-button>
														</el-col>
														<el-col
															class="ml-3 mt-1"
															v-if="item.showDropdown"
															:span="1"
														>
															<el-button
																@click="success_change_serial_number(item, idx)"
																size="mini"
																icon="el-icon-check"
																style="
																	border-radius: 12px;
																	color: green;
																	border-color: green;
																"
															></el-button>
														</el-col>

														<el-col
															:span="item.type == 'Checklist' ? 18 : 19"
															:offset="0"
														>
															<div
																style="font-size: 14px"
																:style="
																	item.showDropdown ? 'margin-left:20px' : ''
																"
															>
																{{ item.name }}
															</div>
														</el-col>
														<el-col
															style="margin-top: -10px"
															v-if="item.type == 'Yes / No'"
															:span="2"
															:offset="1"
														>
															<div v-if="scoringType == 'Score for each step'">
																Points - {{ item.total_points }}
															</div>
														</el-col>
													</el-row>
													<el-row style="margin-top: 5px">
														<el-col :span="22" :offset="2">
															<div
																style="font-size: 13px"
																v-html="item.description"
															></div>
														</el-col>
													</el-row>
													<el-row
														v-if="
															item.form_question_attachments_list.length != 0
														"
														style="margin-top: 10px"
													>
														<el-col :span="2" :offset="1">
															<span>
																<div
																	@click="
																		item.form_question_attachments_list
																			.length != 0
																			? get_image(
																					item.form_question_attachments_list
																			  )
																			: ''
																	"
																	style="
																		color: #f9a168;
																		font-size: 13px;
																		cursor: pointer;
																	"
																>
																	<b><u>View Media</u></b>
																</div>
															</span>
														</el-col>
														<el-col :span="1">
															<img
																width="15px"
																src="../../../assets/icons/Attach.png"
															/>
														</el-col>
													</el-row>
													<!-- types -->
													<el-row
														style="margin-top: 30px"
														v-if="item.type == 'Yes / No'"
													>
														<el-col :span="6">
															<el-button class="button-class-white-dialog">
																Yes
															</el-button>
															<el-button class="button-class-white-dialog">
																No
															</el-button>
														</el-col>
													</el-row>
													<el-row
														style="margin-top: 10px"
														v-if="item.type == 'Long Text'||item.type == 'Long text'"
													>
														<el-col :span="23" :offset="1">
															<el-input
																:disabled="item.marked_as_na"
																type="textarea"
																:rows="2"
																placeholder="Enter long description"
																v-model="item.text_input"
																class="input-class"
															>
															</el-input>
														</el-col>
													</el-row>
													<el-row
														style="margin-top: 10px"
														v-if="item.type == 'Signature'"
													>
														<el-col :span="12" :offset="1">
															<el-input
																type="textarea"
																:rows="3"
																placeholder="Enter Signature"
																class="input-class"
															>
															</el-input>
														</el-col>
													</el-row>
													<el-row
														style="margin-top: 10px"
														v-if="item.type == 'Dropdown'"
													>
														<el-col :span="6" :offset="1">
															<el-select
																id="ns-sec-input-01"
																class="select mt-2 ns-sec-input-type"
																filterable
																placeholder="Select"
																clearable
															>
																<el-option
																	v-for="(
																		item_r, key_r
																	) in item.input_options_list"
																	:key="key_r"
																	:label="splitOptionText(item_r.name)"
																	:value="item_r.id"
																>
																</el-option>
															</el-select>
														</el-col>
													</el-row>
													<el-row
														style="margin-top: 10px"
														v-if="item.type == 'Short text'"
													>
														<el-col :span="10" :offset="1">
															<el-input
																:disabled="item.marked_as_na"
																type="text"
																v-model="item.text_input"
																placeholder="Enter short description"
																class="input-class"
															/>
														</el-col>
													</el-row>
													<el-row
														style="margin-top: 10px"
														v-if="item.type == 'Number input'"
													>
														<el-col :span="10" :offset="1">
															<el-input
																:disabled="item.marked_as_na"
																type="number"
																v-model="item.number_input"
																placeholder="Enter number"
																class="input-class"
															/>
														</el-col>
													</el-row>
													<el-row
														style="margin-top: 10px"
														v-if="item.type == 'Temperature'"
													>
														<el-col :span="2" :offset="1">
															<span>Test Value</span>
														</el-col>
														<el-col :span="5">
															<span>
																<el-input
																	:disabled="item.marked_as_na"
																	type="text"
																	v-model="item.number_input"
																	placeholder="Enter Temperature"
																	style="background: white"
																	class="input-class"
																/>
															</span>
														</el-col>
														<el-col :span="2" :offset="2">
															<span>Retest Value</span>
														</el-col>
														<el-col :span="5" :offset="1">
															<span>
																<el-input
																	:disabled="item.marked_as_na"
																	type="text"
																	v-model="item.repeat_number_input"
																	placeholder="Enter Temperature"
																	style="background: white"
																	class="input-class"
																/>
															</span>
														</el-col>
													</el-row>
													<el-row
														style="margin-top: 10px"
														v-if="item.type == 'TPM'"
													>
														<el-col :span="2" :offset="1">
															<span>Test Value</span>
														</el-col>
														<el-col :span="5">
															<span>
																<el-input
																	:disabled="item.marked_as_na"
																	type="text"
																	v-model="item.number_input"
																	placeholder="Enter TPM"
																	style="background: white"
																	class="input-class"
																/>
															</span>
														</el-col>
														<el-col :span="2" :offset="2">
															<span>Retest Value</span>
														</el-col>
														<el-col :span="5" :offset="1">
															<span>
																<el-input
																	:disabled="item.marked_as_na"
																	type="text"
																	v-model="item.repeat_number_input"
																	placeholder="Enter TPM"
																	style="background: white"
																	class="input-class"
																/>
															</span>
														</el-col>
													</el-row>
													<div
														style="margin-top: 10px"
														v-if="item.type == 'Select any one'"
													>
														<el-row
															v-for="(obj, key) in item.input_options_list"
															:key="key"
															class="mb-3 mt-3"
														>
															<el-col :span="20" :offset="1">
																<el-radio-group>
																	<el-radio :label="obj.name">{{
																		obj.name
																	}}</el-radio>
																</el-radio-group>
																<span
																	style="font-size: 12px; margin-left: 30px"
																>
																	<b>Points - {{ obj.value }}</b>
																</span>
															</el-col>
														</el-row>
													</div>
													<div
														style="margin-top: 10px"
														v-if="item.type == 'Multiselect'"
													>
														<el-row
															class="mt-3 mb-3"
															v-for="(obj, key) in item.input_options_list"
															:key="key"
														>
															<el-col :span="1" :offset="1">
																<input
																	:disabled="item.marked_as_na"
																	type="checkbox"
																	style="width: 17px; height: 17px"
																/>
															</el-col>
															<el-col :span="20">
																<span
																	style="margin-top: -3px; margin-left: -15px"
																>
																	{{ obj.name }}
																	<span
																		style="
																			margin-top: -15px;
																			margin-left: 30px;
																			font-size: 12px;
																		"
																	>
																		<b>Points - {{ obj.value }}</b>
																	</span>
																</span>
															</el-col>
														</el-row>
													</div>
													<el-row
														style="margin-top: 10px"
														v-if="item.type == 'Date'"
													>
														<el-col :span="7" :offset="1">
															<el-date-picker
																style="margin-top: 10px; width: 95%"
																v-model="item.date_input"
																type="date"
																placeholder="Select Date"
																class="date"
																format="yyyy-MM-dd"
																value-format="yyyy-MM-dd"
															>
															</el-date-picker>
														</el-col>
													</el-row>
													<el-row
														style="margin-top: 10px"
														v-if="item.type == 'Time'"
													>
														<el-col :span="7" :offset="1">
															<el-time-select
																v-model="item.time_input"
																:picker-options="{
																	start: '00:00',
																	step: '00:15',
																	end: '23:45',
																}"
																placeholder="Select time"
																class="date"
															>
															</el-time-select>
														</el-col>
													</el-row>
													<el-row
														style="margin-top: 10px"
														v-if="item.type == 'Datetime'"
													>
														<el-col :span="6" :offset="1">
															<el-date-picker
																style="margin-top: 10px; width: 95%"
																v-model="item.date"
																type="datetime"
																placeholder="Select Date & Time"
																class="date"
																format="yyyy-MM-dd HH:mm"
															>
															</el-date-picker>
														</el-col>
													</el-row>
													<!-- item.stopwatches[attemptIndex].time -->
													<el-row
														v-if="item.type === 'Timer'"
														style="margin-top: 10px"
													>
														<el-col :span="24" :offset="1">
															<div
																v-for="(
																	attempt, attemptIndex
																) in item.timer_attempts"
																:key="attemptIndex"
																class="stopwatch-container"
															>
																<div class="time-index">
																	Time {{ attemptIndex + 1 }}
																</div>
																<span
																	v-if="
																		item.stopwatches &&
																		item.stopwatches[attemptIndex]
																	"
																	class="stopwatch"
																>
																	{{
																		formatTime(
																			item.stopwatches[attemptIndex].time
																		).formattedTime
																	}}
																</span>

																<el-button
																	class="button-class-white2"
																	size="mini"
																	style="
																		border: none;
																		margin: 0px;
																		height: 30px;
																	"
																	:disabled="
																		shouldDisableStart(idx, attemptIndex, item)
																	"
																	@click="
																		startStopwatch(idx, attemptIndex, item)
																	"
																	v-if="item.showStartButton[attemptIndex]"
																>
																	Start
																</el-button>
																<el-button
																	class="button-class-white2"
																	size="mini"
																	style="
																		border: none;
																		margin: 0px;
																		height: 30px;
																	"
																	@click="
																		stopStopwatch(idx, attemptIndex, item)
																	"
																	v-if="item.showStopButton[attemptIndex]"
																>
																	Stop
																</el-button>
																<el-button
																	class="button-class-white2"
																	size="mini"
																	style="
																		border: none;
																		margin: 0px;
																		height: 30px;
																	"
																	@click="
																		resetStopwatch(idx, attemptIndex, item)
																	"
																	v-if="item.showResetButton[attemptIndex]"
																>
																	Reset
																</el-button>
															</div>
														</el-col>
													</el-row>
													<el-row
														v-if="item.type === 'Timer'"
														style="margin-top: 10px"
													>
														<el-col :span="24" :offset="1">
															<div class="stopwatch-container">
																<div class="time-index">Total Time:</div>
																<div
																	class="stopwatch"
																	style="margin-left: 72px"
																>
																	<strong>{{ totalTime(item) }}</strong>
																</div>
															</div>
															<div class="stopwatch-container">
																<div class="time-index">Average Time:</div>
																<div
																	class="stopwatch"
																	style="margin-left: 52px"
																>
																	<strong>{{ averageTime(item) }}</strong>
																</div>
															</div>
														</el-col>
													</el-row>
													<el-row
														style="margin-top: 10px"
														v-if="item.type == 'Date and Time'"
													>
														<el-col :span="4" :offset="1">
															<el-date-picker
																v-model="item.date"
																type="date"
																placeholder="Select Date"
																default-value="2010-10-01"
															>
															</el-date-picker>
														</el-col>
														<el-col :span="2" :offset="1">
															<el-time-select
																v-model="item.time"
																:picker-options="{
																	start: '00:00',
																	step: '00:30',
																	end: '23:45',
																}"
																placeholder="Select time"
															>
															</el-time-select>
														</el-col>
													</el-row>
													<el-row
														style="margin-top: 10px"
														v-if="item.type == 'Rating'"
													>
														<el-col :span="1" :offset="1">
															<div>
																{{ item.minimum_value }}
															</div>
														</el-col>
														<el-col :span="16">
															<span>
																<el-slider
																	:disabled="item.marked_as_na"
																	v-model="item.rating"
																	:min="item.minimum_value"
																	:max="item.maximum_value"
																	show-stops
																>
																</el-slider>
															</span>
														</el-col>
														<el-col :span="1" :offset="1">
															<div>
																{{ item.maximum_value }}
															</div>
														</el-col>
													</el-row>
													<el-row v-if="item.type == 'Mobile number'">
														<el-col :span="4" :offset="1">
															<input
																type="number"
																pattern="/^-?\d+\.?\d*$/"
																onKeyPress="if(this.value.length==10) return false;"
																v-model="item.phone_number"
																placeholder="Enter Mobile Number"
																class="input-class-dialog mt-2"
																style="width: 300px"
															/>
														</el-col>
													</el-row>
													<el-row v-if="item.type == 'Email'">
														<el-col :span="4" :offset="1">
															<input
																v-model="item.email"
																type="email"
																id="email"
																name="email"
																class="input-class-dialog mt-2"
																style="width: 300px"
																placeholder="example@example.com"
															/>
														</el-col>
													</el-row>
													<!-- types close -->
													<el-row style="margin-top: 10px">
														<el-col :span="1" :offset="14">
															<img
																width="25px"
																src="../../../assets/icons/Camera.png"
															/>
														</el-col>
														<el-col style="margin-top: 0px" :span="1">
															<span style="margin-left: -10px">Image </span>
														</el-col>
														<el-col style="margin-left: 10px" :span="1">
															<img
																width="25px"
																src="../../../assets/icons/Comment1.png"
															/>
														</el-col>
														<el-col style="margin-top: 0px" :span="1">
															<span style="margin-left: -10px">Comment</span>
														</el-col>
														<el-col
															style="margin-left: 40px; margin-top: 0px"
															:span="1"
														>
															<img
																width="25px"
																src="../../../assets/icons/ComputerSupport1.png"
															/>
														</el-col>
														<el-col
															style="margin-left: -8px; margin-top: 0px"
															:span="2"
														>
															<span>Raise Ticket</span>
														</el-col>
														<el-col
															style="margin-left: 0px; margin-top: 5px"
															:span="1"
														>
															<span>NA</span>
														</el-col>
														<el-col
															style="margin-left: -20px; margin-top: 2px"
															:span="1"
														>
															<el-switch
																v-model="item.is_not_applicable"
																active-color="#41BE62"
															>
															</el-switch>
														</el-col>
													</el-row>
													<!-- Dependent Question Start -->
													<el-row
														style="margin-top: 10px"
														v-if="item.dependant_question_available"
													>
														<el-col :span="22" :offset="1">
															<el-row v-if="item.expanded == true">
																<el-col class="mt-2" :span="1">
																	<img
																		width="25px"
																		src="../../../assets/icons/Link.png"
																	/>
																</el-col>
																<el-col :span="23">
																	<el-card
																		style="
																			border: 1px dashed;
																			border-color: #f9a168;
																			border-radius: 12px;
																			background-color: #fff9f4;
																		"
																		@click.native="collapse_item(item)"
																	>
																		<el-row style="cursor: pointer">
																			<el-col
																				v-if="
																					item.dependent_inputType ==
																					'Checklist'
																				"
																				:span="1"
																			>
																				<input
																					type="checkbox"
																					style="width: 17px; height: 17px"
																				/>
																			</el-col>
																			<el-col
																				:style="
																					item.dependent_inputType ==
																					'Checklist'
																						? 'margin-top: -2px; margin-left:-20px'
																						: ''
																				"
																				:span="
																					item.dependent_inputType ==
																					'Checklist'
																						? 22
																						: 23
																				"
																			>
																				<div>
																					{{ item.dependent_name }}
																				</div>
																			</el-col>
																			<el-col :span="1">
																				<el-button
																					icon="el-icon-arrow-down"
																					style="
																						border: none;
																						color: black;
																						font-size: 12px;
																						margin-top: -30px;
																						background-color: #fff9f4;
																					"
																					plain
																				>
																				</el-button>
																			</el-col>
																		</el-row>
																		<el-row
																			style="margin-top: 30px"
																			v-if="
																				item.dependent_inputType == 'Yes / No'
																			"
																		>
																			<el-col :span="6">
																				<el-button
																					class="button-class-white-dialog"
																				>
																					Yes
																				</el-button>
																				<el-button
																					class="button-class-white-dialog"
																				>
																					No
																				</el-button>
																			</el-col>
																		</el-row>
																		<el-row
																			v-if="
																				item.dependent_inputType == 'Long Text'
																			"
																		>
																			<el-col :span="23" :offset="1">
																				<el-input
																					:disabled="item.marked_as_na"
																					type="textarea"
																					:rows="2"
																					placeholder="Enter long description"
																					v-model="item.text_input"
																					class="input-class"
																				>
																				</el-input>
																			</el-col>
																		</el-row>
																		<el-row
																			v-if="
																				item.dependent_inputType == 'Short text'
																			"
																		>
																			<el-col :span="10" :offset="1">
																				<el-input
																					:disabled="item.marked_as_na"
																					type="text"
																					v-model="item.text_input"
																					placeholder="Enter short description"
																					class="input-class"
																				/>
																			</el-col>
																		</el-row>
																		<el-row
																			v-if="
																				item.dependent_inputType ==
																				'Number input'
																			"
																		>
																			<el-col :span="10">
																				<el-input
																					:disabled="item.marked_as_na"
																					type="text"
																					v-model="item.number_input"
																					placeholder="Enter number"
																					class="input-class"
																				/>
																			</el-col>
																		</el-row>
																		<el-row
																			v-if="
																				item.dependent_inputType ==
																				'Temperature'
																			"
																		>
																			<el-col :span="2">
																				<span>Test Value</span>
																			</el-col>
																			<el-col :span="5">
																				<span>
																					<el-input
																						:disabled="item.marked_as_na"
																						type="text"
																						v-model="item.number_input"
																						placeholder="Enter Temperature"
																						class="input-class"
																					/>
																				</span>
																			</el-col>
																			<el-col :span="3" :offset="1">
																				<span>Retest Value</span>
																			</el-col>
																			<el-col :span="5">
																				<span>
																					<el-input
																						:disabled="item.marked_as_na"
																						type="text"
																						v-model="item.number_input"
																						placeholder="Enter Temperature"
																						class="input-class"
																					/>
																				</span>
																			</el-col>
																		</el-row>
																		<el-row
																			v-if="item.dependent_inputType == 'TPM'"
																		>
																			<el-col :span="2">
																				<span>Test Value</span>
																			</el-col>
																			<el-col :span="5">
																				<span>
																					<el-input
																						:disabled="item.marked_as_na"
																						type="text"
																						v-model="item.number_input"
																						placeholder="Enter TPM"
																						class="input-class"
																					/>
																				</span>
																			</el-col>
																			<el-col :span="3" :offset="1">
																				<span>Retest Value</span>
																			</el-col>
																			<el-col :span="5">
																				<span>
																					<el-input
																						:disabled="item.marked_as_na"
																						type="text"
																						v-model="item.number_input"
																						placeholder="Enter TPM"
																						class="input-class"
																					/>
																				</span>
																			</el-col>
																		</el-row>
																		<div
																			v-if="
																				item.dependent_inputType ==
																				'Select any one'
																			"
																		>
																			<el-row
																				v-for="(obj, key) in item
																					.child_form_questions_list[0]
																					.input_options_list"
																				:key="key"
																				class="mb-3 mt-3"
																			>
																				<el-col :span="23">
																					<el-radio-group>
																						<el-radio :label="obj.name">{{
																							obj.name
																						}}</el-radio>
																					</el-radio-group>
																					<span
																						style="
																							font-size: 12px;
																							margin-left: 30px;
																						"
																					>
																						<b>Points - {{ obj.value }}</b>
																					</span>
																				</el-col>
																				<!-- <el-col :span="3"> </el-col> -->
																			</el-row>
																		</div>
																		<div
																			v-if="
																				item.dependent_inputType ==
																				'Multiselect'
																			"
																		>
																			<el-row
																				class="mt-3 mb-3"
																				v-for="(obj, key) in item
																					.child_form_questions_list[0]
																					.input_options_list"
																				:key="key"
																			>
																				<el-col :span="1">
																					<input
																						type="checkbox"
																						style="width: 17px; height: 17px"
																					/>
																				</el-col>
																				<el-col :span="20">
																					<span style="margin-top: -3px">
																						{{ obj.name }}
																					</span>
																					<span
																						style="
																							margin-top: -10px;
																							margin-left: 40px;
																							font-size: 12px;
																						"
																					>
																						<b>Points - {{ obj.value }}</b>
																					</span>
																				</el-col>
																				<!-- <el-col :span="5"> </el-col> -->
																			</el-row>
																		</div>
																		<el-row
																			style="margin-top: 10px"
																			v-if="item.dependent_inputType == 'Date'"
																		>
																			<el-col :span="4">
																				<el-date-picker
																					v-model="item.dependent_date"
																					type="date"
																					placeholder="Select Date"
																					default-value="2010-10-01"
																				>
																				</el-date-picker>
																			</el-col>
																		</el-row>
																		<el-row
																			style="margin-top: 10px"
																			v-if="
																				item.dependent_inputType ==
																				'Date and Time'
																			"
																		>
																			<el-col :span="4">
																				<el-date-picker
																					v-model="item.dependent_date"
																					type="date"
																					placeholder="Select Date"
																					default-value="2010-10-01"
																				>
																				</el-date-picker>
																			</el-col>
																			<el-col :span="2" :offset="1">
																				<el-time-select
																					v-model="item.dependent_time"
																					:picker-options="{
																						start: '00:00',
																						step: '00:30',
																						end: '23:45',
																					}"
																					placeholder="Select time"
																				>
																				</el-time-select>
																			</el-col>
																		</el-row>
																		<el-row
																			v-if="
																				item.dependent_inputType == 'Rating'
																			"
																		>
																			<el-col :span="1">
																				<div>
																					<!-- {{ item }} -->
																					{{
																						item.child_form_questions_list[0]
																							.minimum_value
																					}}
																				</div>
																			</el-col>
																			<el-col :span="16">
																				<span>
																					<el-slider
																						v-model="item.dependent_rating"
																						:min="
																							item.child_form_questions_list[0]
																								.minimum_value
																						"
																						:max="
																							item.child_form_questions_list[0]
																								.maximum_value
																						"
																						show-stops
																					>
																					</el-slider>
																				</span>
																			</el-col>
																			<el-col :span="1" :offset="1">
																				<div>
																					{{
																						item.child_form_questions_list[0]
																							.maximum_value
																					}}
																				</div>
																			</el-col>
																		</el-row>
																		<el-row
																			v-if="
																				item.dependent_inputType ==
																				'Phone Number'
																			"
																		>
																			<el-col :span="4">
																				<input
																					type="number"
																					pattern="/^-?\d+\.?\d*$/"
																					onKeyPress="if(this.value.length==10) return false;"
																					v-model="item.dependent_phone_number"
																					placeholder="Enter Phone Number"
																					class="input-class-dialog mt-2"
																					style="width: 300px"
																				/>
																			</el-col>
																		</el-row>
																		<el-row
																			v-if="item.dependent_inputType == 'Email'"
																		>
																			<el-col :span="4">
																				<input
																					v-model="item.dependent_email"
																					type="email"
																					id="email"
																					name="email"
																					class="input-class-dialog mt-2"
																					style="width: 300px"
																					placeholder="example@example.com"
																				/>
																			</el-col>
																		</el-row>
																		<el-row style="margin-top: 10px">
																			<el-col :span="1" :offset="13">
																				<img
																					width="25px"
																					src="../../../assets/icons/Camera.png"
																				/>
																			</el-col>
																			<el-col style="margin-top: 0px" :span="1">
																				<span style="margin-left: -3px"
																					>Image
																				</span>
																			</el-col>
																			<el-col
																				style="margin-left: 10px"
																				:span="1"
																			>
																				<img
																					width="25px"
																					src="../../../assets/icons/Comment1.png"
																				/>
																			</el-col>
																			<el-col style="margin-top: 0px" :span="1">
																				<span style="margin-left: -3px"
																					>Comment</span
																				>
																			</el-col>
																			<el-col
																				style="
																					margin-left: 40px;
																					margin-top: 0px;
																				"
																				:span="1"
																			>
																				<img
																					width="25px"
																					src="../../../assets/icons/ComputerSupport1.png"
																				/>
																			</el-col>
																			<el-col
																				style="
																					margin-left: -3px;
																					margin-top: 0px;
																				"
																				:span="3"
																			>
																				<span>Raise Ticket</span>
																			</el-col>
																			<el-col
																				style="
																					margin-left: -20px;
																					margin-top: 0px;
																				"
																				:span="1"
																			>
																				<span>NA</span>
																			</el-col>
																			<el-col
																				style="
																					margin-left: -10px;
																					margin-top: 2px;
																				"
																				:span="1"
																			>
																				<el-switch
																					v-model="notApplicable"
																					active-color="#41BE62"
																				>
																				</el-switch>
																			</el-col>
																		</el-row>
																	</el-card>
																</el-col>
															</el-row>
															<div v-if="item.expanded == false">
																<el-row>
																	<el-col class="mt-2" :span="1">
																		<img
																			width="25px"
																			src="../../../assets/icons/Link.png"
																		/>
																	</el-col>
																	<el-col :span="23">
																		<el-card
																			style="
																				border: 1px dashed;
																				border-color: #f9a168;
																				height: 60px;
																				border-radius: 12px;
																				background-color: #fff9f4;
																			"
																			@click.native="expand_item(item)"
																		>
																			<el-row style="cursor: pointer">
																				<el-col
																					v-if="
																						item.dependent_inputType ==
																						'Checklist'
																					"
																					:span="1"
																				>
																					<input
																						type="checkbox"
																						style="width: 17px; height: 17px"
																					/>
																				</el-col>
																				<el-col
																					:span="
																						item.dependent_inputType ==
																						'Checklist'
																							? 22
																							: 23
																					"
																				>
																					<div>
																						{{ item.dependent_name }}
																					</div>
																				</el-col>
																				<el-col :span="1">
																					<el-button
																						icon="el-icon-arrow-right"
																						style="
																							border: none;
																							color: black;
																							font-size: 12px;
																							margin-top: -30px;
																							background-color: #fff9f4;
																						"
																						plain
																					>
																					</el-button>
																				</el-col>
																			</el-row>
																		</el-card>
																	</el-col>
																</el-row>
															</div>
														</el-col>
													</el-row>
													<!-- Dependent Question End -->
												</el-card>
											</div>
										</el-col>
										<el-col
											:style="
												item.default
													? 'margin-top: -25px;margin-left:20px'
													: 'margin-top: 0px; margin-left:20px'
											"
											:span="1"
										>
											<img
												@click="edit_question(item)"
												width="15px"
												src="../../../assets/icons/edit_pencil_icon.png"
												style="cursor: pointer"
											/>
										</el-col>
										<el-col
											:style="
												item.default
													? 'margin-top: -25px; margin-left:-20px'
													: 'margin-top: 0px; margin-left:-20px'
											"
											:span="1"
										>
											<el-button
												@click="delete_form_row(item)"
												icon="el-icon-delete"
												style="
													border: none;
													font-size: 20px;
													margin-left: -15px;
													cursor: pointer;
												"
												plain
											></el-button>
										</el-col>
									</el-row>
									<div
										style="border: 1px solid; border-color: #d3d3d3"
										class="my-5"
									></div>
								</div>
							</div>
							<el-row
								v-if="current_view == 'ADD'"
								style="margin-top: 20px; margin-bottom: 0px"
								:gutter="10"
							>
								<el-col style="margin-top: 10px" :span="2" :offset="17">
									<el-button
										class="button-class-white2"
										style="border: none"
										@click="go_to_list_forms()"
									>
										Cancel
									</el-button>
								</el-col>
								<el-col style="margin-top: -40px" :span="3">
									<el-button
										:disabled="
											sectionItems[0].editable
												? sectionItems[0].editable
												: sectionItems[0].form_questions_list.length == 0
										"
										@click="goToPreview(1)"
										class="button-class"
										style="width: 150px"
									>
										Continue
									</el-button>
								</el-col>
							</el-row>
							<div
								v-if="current_view == 'EDIT' && formEditable == false"
								style="display: flex; margin-top: 30px"
							>
								<div style="margin-left: auto; margin-right: 10%">
									<el-button
										class="button-class-white2"
										style="border: none"
										@click="go_to_list_forms()"
									>
										Cancel
									</el-button>
									<el-button
										class="button-class-white-dialog"
										@click="go_to_list_forms()"
									>
										Save & Exit
									</el-button>
								</div>
							</div>
						</el-card>
					</div>
					<!-- </el-card> -->
				</el-col>
			</el-row>
			<el-row v-if="tabItems[1].active" style="margin-top: 10px">
				<el-col :span="24">
					<el-card
						style="
							padding-left: 50px;
							overflow-y: auto;
							min-height: 75vh;
							max-height: 75vh;
							border-bottom: none;
						"
						shadow="never"
					>
						<el-row class="mb-2">
							<el-col :span="1" :offset="21">
								<div style="font-weight: 600; font-size: 13px">
									<u>Preview</u>
								</div>
							</el-col>
						</el-row>
						<el-row>
							<el-col
								v-if="active_view == 'WEB'"
								:span="active_view == 'WEB' ? 18 : 0"
							>
								<div>
									<h3>
										{{ title }}
									</h3>
								</div>
								<div class="mt-2" style="font-size: 12px">{{ category }}</div>
							</el-col>
							<el-col :span="1" :offset="active_view == 'WEB' ? 3 : 21">
								<img
									width="30px"
									src="../../../assets/icons/Web.png"
									:class="
										active_view == 'WEB' ? 'active-view' : 'inactive-view'
									"
									@click="active_view = 'WEB'"
									style="position: relative; z-index: 1"
								/>
							</el-col>
							<el-col style="margin-left: -15px" :span="1">
								<div
									style="
										border-left: 2px solid;
										border-color: #f9a168;
										height: 30px;
									"
								></div>
							</el-col>
							<el-col :span="1" style="margin-left: -45px; margin-top: -0px">
								<img
									@click="active_view = 'PHONE'"
									width="30px"
									src="../../../assets/icons/Smartphone.png"
									:class="
										active_view == 'PHONE' ? 'active-view' : 'inactive-view'
									"
								/>
							</el-col>
						</el-row>
						<el-row v-if="active_view == 'WEB'">
							<el-col :span="24">
								<FormPreviewWebVue
									:preview_formItemArray="preview_formItemArray"
									:scoringType="scoringType"
								/>
							</el-col>
						</el-row>
						<div v-if="active_view == 'PHONE'">
							<FormPreviewPhoneVue
								:preview_formItemArray="preview_formItemArray"
								:title="title"
								:scoringType="scoringType"
							/>
						</div>
					</el-card>
					<el-card
						v-if="active_view == 'WEB'"
						style="border-top: none"
						shadow="never"
					>
						<el-row style="margin-bottom: 0px">
							<el-col :span="3" :offset="17">
								<el-button
									class="button-class-white-dialog"
									style="width: 100px"
									@click="goToprevious_tab()"
								>
									Back
								</el-button>
							</el-col>
							<el-col style="margin-top: -50px" :span="3">
								<el-button
									@click="goToPreview(2)"
									class="button-class"
									style="width: 150px"
								>
									Continue
								</el-button>
							</el-col>
						</el-row>
					</el-card>
					<el-card
						v-if="active_view == 'PHONE'"
						style="border-top: none; margin-top: 0px"
						shadow="never"
					>
						<el-row>
							<el-col :span="3" :offset="17">
								<el-button
									class="button-class-white-dialog"
									style="width: 100px"
									@click="goToprevious_tab()"
								>
									Back
								</el-button>
							</el-col>
							<el-col style="margin-top: -50px" :span="3">
								<el-button
									@click="goToPreview(2)"
									class="button-class"
									style="width: 150px"
								>
									Continue
								</el-button>
							</el-col>
						</el-row>
					</el-card>
				</el-col>
			</el-row>
			<el-row v-if="tabItems[2].active" style="margin-top: 10px">
				<el-col :span="24">
					<Launch
						@create_project="create_project_condition"
						:category="category"
						:title="title"
						:formDetails="formDetails"
						@close="get_preview_screen"
						:show_add_to_project="show_add_to_project"
						@get_forms="go_to_list_forms"
					/>
				</el-col>
			</el-row>
		</div>
		<el-row style="padding-left: 0px; margin-top: 20px" v-if="createProject">
			<el-col :span="24">
				<CreateProjectVue
					:title="title"
					@closed="get_launch_screen"
					@close="get_form_screen"
					:storeObj="storeObj"
				/>
			</el-col>
		</el-row>
		<FormInputDialogVue
			:formDialog="formDialog"
			@close="addToFormArrayCondition"
			@clicked="addToFormArray"
			:storeObj="storeObj"
			:inputTypeItems="inputTypeItems"
			:current_selection="current_selection"
			:scoringType="scoringType"
			:category_items="category_items"
			:sectionItems="sectionItems"
		/>
		<AddEditCategoryVue
			:storeObj="storeObj"
			:addEditDialog="addEditDialog"
			@close="addEditDialog = false"
			@clicked="get_category_data"
			:category_items="category_items"
		/>
		<AddEditInputTypeVue
			:storeObj="storeObj"
			:addEditInputDialog="addEditInputDialog"
			@close="addEditInputDialog = false"
			:inputTypeItems="inputTypeItems"
			@clicked="get_input_type_data"
		/>
		<ViewQuestionImagesVue
			:imagesArray="imagesArray"
			:viewQuestionImagesDialog="viewQuestionImagesDialog"
			@close="viewQuestionImagesDialog = false"
		/>
		<EditQuestionVue
			:storeObj="storeObj"
			:inputTypeItems="inputTypeItems"
			:current_selection="current_selection"
			:scoringType="scoringType"
			:editformDialog="editformDialog"
			@close="get_edit_question_values"
			@clicked="addToFormArray"
			:category_items="category_items"
		/>
		<DeleteConfirmationVue
			:deleteDialog="deleteDialog"
			:confirmationObject="confirmationObject"
			@cancel="deleteDialog = false"
			@success="delete_api_toggle"
			:confirmationTitle="confirmationTitle"
		/>
	</div>
</template>

<script>
import FormInputDialogVue from "./FormInputDialog.vue";
// import items from "./inputTypeItems.js";
import formBuilderServices from "../../../services/formBuilderServices";
import FormPreviewWebVue from "./FormPreviewWeb.vue";
import FormPreviewPhoneVue from "./FormPreviewPhone.vue";
import Launch from "./Launch.vue";
import CreateProjectVue from "./CreateProject.vue";
import AddEditCategoryVue from "./AddEditCategory.vue";
import AddEditInputTypeVue from "./AddEditInputType.vue";
import ViewQuestionImagesVue from "./ViewQuestionImages.vue";
import EditQuestionVue from "./EditQuestion.vue";
import DeleteConfirmationVue from "./V2Projects/DeleteConfirmation.vue";
var moment = require("moment");

export default {
	components: {
		FormInputDialogVue,
		FormPreviewWebVue,
		FormPreviewPhoneVue,
		Launch,
		CreateProjectVue,
		AddEditCategoryVue,
		AddEditInputTypeVue,
		ViewQuestionImagesVue,
		EditQuestionVue,
		DeleteConfirmationVue,
	},
	data: () => ({
		moment: moment,
		confirmationObject: {},
		confirmationTitle: "",
		deleteDialog: false,
		editformDialog: false,
		pos_neg: "",
		pos_neg_2: "",
		pos_neg_items: [
			{ name: "+ve", value: "positive" },
			{ name: "-ve", value: "negative" },
		],
		active_view: "WEB",
		category_card: false,
		current_selection: "",
		search: "",
		height: null,
		current_view: "LIST", // LIST, ADD
		step: 1, // 1, 2, 3, 4
		title: "",
		category: "",
		category_items: [],
		tabItems: [
			{ name: "Create Form", active: true },
			{ name: "Preview", active: false },
			{ name: "Launch", active: false },
		],
		sectionItems: [{ slno: 0, name: "", editable: true }],
		selectedStepItem: {},
		show_input_card: false,
		inputType: "",
		inputTypeItems: [],
		formDialog: false,
		storeObj: {},
		formItemArray: [],
		show_input: false,
		notApplicable: true,
		raiseTicket: true,
		default_form: false,
		show_retest: false,
		show_retest_tpm: false,
		default: false,
		formLists: [],
		step_selected: 0,
		formEditable: false,
		sectionEditable: false,
		createProject: false,
		addEditDialog: false,
		category_obj: {},
		addEditInputDialog: false,
		scoringType: "Not Applicable",
		scoringType_items: [
			{ name: "Not Applicable", value: "not_applicable" },
			{ name: "Score for overall form", value: "all_pass" },
			{ name: "Score for each step", value: "by_steps" },
		],
		yes_value_points: "",
		no_value_points: "",
		yes_no_value_points_items: [],
		no_value: "One or more Fail",
		yes_value: "All Pass",
		yes_value_items: [
			{ name: "All Pass", value: "All Pass" },
			{ name: "One or more Fail", value: "One or more Fail" },
		],
		markCritical: false,
		preview_formItemArray: [],
		show_image: false,
		imagesArray: [],
		viewQuestionImagesDialog: false,
		show_add_to_project: false,
		expectedResponse_Id1: null,
		expectedResponse_Id2: null,
		formListResponse: {},
		deleteItemName: null,
		isloading: false,
		perPage: 10,
		currentPage: 1,
		searched_form_name: "",
		selected_form: [],
		searched_category_name: "",
		selected_category: [],
		show_mark_all_yes_no: false,
		show_mark_all_na: false,
		show_yes_no_boolean: false,
		showEditIcon: true,
		serialNumberItems: [],
		stopwatches: [],
		isRunning: [],
		interval: [],
		showStartButton: [],
		showStopButton: [],
		showResetButton: [],
		nextIndex: null,
		sectionStopwatches: [],
		sectionLoading: false,
	}),
	watch: {
		current_view(val) {
			if (val == "ADD" || val == "EDIT") {
				this.list_all_categories();
				for (let i = 0; i <= 500; i++) {
					this.yes_no_value_points_items.push({ name: i, value: i });
				}
			}
		},
		step(val) {
			if (val == 2) {
				if (this.current_view == "ADD") {
					this.call_form_list_api(1);
				}
			}
		},
		yes_value(val) {
			if (val == "One or more Fail") this.no_value = "All Pass";
			if (val == "All Pass") this.no_value = "One or more Fail";
		},
		no_value(val) {
			if (val == "One or more Fail") this.yes_value = "All Pass";
			if (val == "All Pass") this.yes_value = "One or more Fail";
		},
	},
	computed: {
		computedFormsList() {
			let arr = [...this.formLists];
			if (this.search) {
				arr = arr.filter(
					(el) =>
						!this.search ||
						el.name.toLowerCase().includes(this.search.toLowerCase())
				);
			}
			if (this.selected_form) {
				arr = arr.filter(
					(el) =>
						!this.selected_form.length || this.selected_form.includes(el.name)
				);
			}
			if (this.selected_category) {
				arr = arr.filter(
					(el) =>
						!this.selected_category.length ||
						this.selected_category.includes(el.category)
				);
			}

			return arr;
		},
		getMargin() {
			let margin = null;
			if (this.step == 2) {
				switch (this.sectionItems.length) {
					case 1:
						margin = `margin-top:170px`;
						break;
					case 2:
						margin = `margin-top:118px`;
						break;
					case 3:
						margin = `margin-top:70px`;
						break;
				}
			} else if (this.step == 3) {
				switch (this.sectionItems.length) {
					case 1:
						margin = `margin-top:140px`;
						break;
					case 2:
						margin = `margin-top:50px`;
						break;
					case 3:
						margin = `margin-top:10px`;
						break;
				}
			}
			return margin;
		},
		startNumber() {
			let start = this.currentPage * this.perPage - (this.perPage - 1);
			return start;
		},
		endNumber() {
			let end = Math.min(
				this.startNumber + this.perPage - 1,
				this.computedFormsList.length
			);
			return end;
		},
		uniqueFormNames() {
			let arr = [...new Set(this.computedFormsList.map((el) => el.name))];
			return arr;
		},
		uniqueCategoryNames() {
			let arr = [...new Set(this.computedFormsList.map((el) => el.category))];
			return arr;
		},
	},
	async created() {
		this.isloading = true;
		this.list_all_input_types();
		this.height = `height: ${window.innerHeight - 150}px`;
		this.list_all_categories();
		setTimeout(() => {
			this.list_forms();
		}, 200);
	},
	methods: {
		splitText(text) {
			const chunkSize = 75;
			const chunks = [];
			let start = 0;
			while (start < text.length) {
				let end = start + chunkSize;
				if (end < text.length) {
					while (end > start && text[end] !== " ") {
						end--;
					}
				}
				if (end === start) {
					end = start + chunkSize;
				}
				chunks.push(text.slice(start, end).trim());
				start = end;
			}
			return chunks;
		},
		splitOptionText(text) {
			const chunks = this.splitText(text);
			return chunks.join("\n"); // Join chunks with a line break or any delimiter you prefer
		},
		shouldDisableStart(index, attemptIndex, item) {
			if (attemptIndex === 0 && !item.isRunning[attemptIndex]) {
				return false;
			}
			if (
				attemptIndex > 0 &&
				item.stopwatches[attemptIndex - 1].stopped &&
				!item.isRunning[attemptIndex]
			) {
				return false;
			}
			if (attemptIndex === item.nextIndex && !item.isRunning[attemptIndex]) {
				return false;
			}
			return true;
		},
		stopStopwatch(index, attemptIndex, item) {
			this.$set(item.showStartButton, attemptIndex, false);
			this.$set(item.showStopButton, attemptIndex, false);
			this.$set(item.showResetButton, attemptIndex, true);
			item.isRunning[attemptIndex] = false;
			clearInterval(item.interval[attemptIndex]);
			item.nextIndex = attemptIndex + 1;
			while (
				item.nextIndex < item.stopwatches.length &&
				item.stopwatches[item.nextIndex].stopped
			) {
				item.nextIndex++;
			}

			for (let i = 0; i < item.stopwatches.length; i++) {
				item.stopwatches[i].new_time = this.formatTime(
					item.stopwatches[i].time
				);
			}
			this.$forceUpdate();
		},
		startStopwatch(index, attemptIndex, item) {
			this.$set(item.showStartButton, attemptIndex, false);
			this.$set(item.showStopButton, attemptIndex, true);
			this.$set(item.stopwatches, attemptIndex, { time: 0 });
			this.$set(item.isRunning, attemptIndex, true);
			item.interval[attemptIndex] = setInterval(() => {
				this.$set(
					item.stopwatches[attemptIndex],
					"time",
					item.stopwatches[attemptIndex].time + 1000
				);
				// Call formatTime for every interval update
				this.formatTime(item.stopwatches[attemptIndex].time, item);
				this.$forceUpdate();
			}, 1000);
		},
		resetStopwatch(index, attemptIndex, item) {
			clearInterval(item.interval[attemptIndex]);
			item.isRunning[attemptIndex] = false;
			item.stopwatches[attemptIndex].time = 0;
			this.$set(item.showStartButton, attemptIndex, true);
			this.$set(item.showStopButton, attemptIndex, false);
			this.$set(item.showResetButton, attemptIndex, false);
			item.stopwatches[attemptIndex].new_time = this.formatTime(
				item.stopwatches[attemptIndex].time
			);
			for (let i = attemptIndex + 1; i < item.stopwatches.length; i++) {
				this.$set(item.showStartButton, i, true); // Show the start button
				this.$set(item.isRunning, i, false); // Ensure it's not running
				this.$set(item.stopwatches[i], "time", 0); // Reset the time
				this.$set(item.showStartButton, i, true); // Enable the button but disable it
			}
			this.$forceUpdate();
		},
		formatTime(time, item) {
			if (isNaN(time) || time < 0) {
				return {
					formattedTime: "00:00:00",
					item: item,
				};
			}
			if (!time) {
				return {
					formattedTime: "00:00:00",
					item: item,
				};
			}
			if (time == 0) {
				return {
					formattedTime: "00:00:00",
					item: item,
				};
			}
			const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
			const minutes = Math.floor((time / (1000 * 60)) % 60);
			const seconds = Math.floor((time / 1000) % 60);
			const formattedTime = `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(
				seconds
			)}`;
			return {
				formattedTime: formattedTime,
				item: item,
			};
		},
		pad(num) {
			return num.toString().padStart(2, "0");
		},
		totalTime(item) {
			let totalMilliseconds = 0;
			item.stopwatches.forEach((stopwatch) => {
				totalMilliseconds += stopwatch.time;
			});
			const totalSeconds = Math.floor(totalMilliseconds / 1000);
			const hours = Math.floor(totalSeconds / 3600);
			const minutes = Math.floor((totalSeconds % 3600) / 60);
			const seconds = totalSeconds % 60;
			return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
		},
		averageTime(item) {
			if (item.stopwatches.length === 0) {
				return "00:00:00";
			}
			const totalMilliseconds = item.stopwatches.reduce(
				(acc, stopwatch) => acc + stopwatch.time,
				0
			);
			const averageMilliseconds = totalMilliseconds / item.stopwatches.length;
			const totalSeconds = Math.floor(averageMilliseconds / 1000);
			const hours = Math.floor(totalSeconds / 3600);
			const minutes = Math.floor((totalSeconds % 3600) / 60);
			const seconds = totalSeconds % 60;
			return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
		},
		call_update_serial_number_api(item, idx) {
			let params = {
				serial_no: item.serial_no,
			};
			formBuilderServices.editQuestion(item.id, params).then((res) => {
				console.log(res, "resssssssssssssssss");
			});
		},
		cancel_change_serial_number(item, idx) {
			item.showDropdown = false;
			item.showEditIcon = false;
			item.serial_no = item.old_serial_no;
			this.$forceUpdate();
			return item;
		},
		success_change_serial_number(item, idx) {
			item.showDropdown = false;
			item.showEditIcon = false;
			let arr1 = this.sectionItems[0].form_questions_list.splice(idx, 1);
			this.insertArrayAt(
				this.sectionItems[0].form_questions_list,
				item.serial_no - 1,
				arr1
			);
			this.sectionItems[0].form_questions_list.forEach((el, index) => {
				el.serial_no = index + 1;
			});
			this.$forceUpdate();
			this.call_update_serial_number_api(item, idx);
			return item;
		},
		insertArrayAt(array, index, arrayToInsert) {
			Array.prototype.splice.apply(array, [index, 0].concat(arrayToInsert));
			return array;
		},
		change_serial_number(item, idx, event) {
			if (event == true) item.old_serial_no = item.serial_no;
			this.$forceUpdate();
			return item;
		},
		show_edit_icon(item) {
			item.editable_icon = true;
			setTimeout(() => {
				item.editable_icon = false;
			}, 2000);
			this.$forceUpdate();
			return item;
		},
		hide_edit_icon(item) {
			item.editable_icon = false;
			this.$forceUpdate();
			return item;
		},
		show_dropdown(item) {
			item.showDropdown = true;
			this.$forceUpdate();

			return item;
		},
		go_to_list_forms() {
			this.list_all_categories();
			setTimeout(() => {
				this.list_forms();
				this.$emit("show_form");
				this.current_view = "LIST";
			}, 200);
		},
		edit_section_row(item, idx) {
			item.editable = true;
			this.$forceUpdate();
			return item;
		},
		call_form_list_api(val) {
			formBuilderServices
				.listQuestion(this.formDetails.id)
				.then(async (res) => {
					this.formListResponse = JSON.parse(res.data);
					this.show_mark_all_na = this.formListResponse.show_mark_all_na;
					this.show_mark_all_yes_no =
						this.formListResponse.show_mark_all_yes_no;

					if (this.current_view == "EDIT") {
						if (this.scoringType == "Score for overall form") {
							this.yes_value =
								this.formListResponse.expected_responses_list[0]
									.status_on_trigger == "pass"
									? "All Pass"
									: "One or more Fail";
							this.no_value =
								this.formListResponse.expected_responses_list[1]
									.status_on_trigger == "pass"
									? "All Pass"
									: "One or more Fail";
							this.pos_neg_2 =
								this.formListResponse.expected_responses_list[1]
									.points_on_trigger < 0
									? "negative"
									: "positive";
							this.pos_neg =
								this.formListResponse.expected_responses_list[0]
									.points_on_trigger < 0
									? "negative"
									: "positive";
							this.no_value_points =
								this.formListResponse.expected_responses_list[1]
									.points_on_trigger < 0
									? parseInt(
											this.formListResponse.expected_responses_list[1].points_on_trigger
												.toString()
												.replace("-", "")
									  )
									: this.formListResponse.expected_responses_list[1]
											.points_on_trigger;
							this.yes_value_points =
								this.formListResponse.expected_responses_list[0]
									.points_on_trigger < 0
									? parseInt(
											this.formListResponse.expected_responses_list[0].points_on_trigger
												.toString()
												.replace("-", "")
									  )
									: this.formListResponse.expected_responses_list[0]
											.points_on_trigger;
						}
					}
					this.sectionItems = JSON.parse(res.data).sections_list;
					if (this.sectionItems.length != 0) {
						for (let i = 0; i < this.sectionItems.length; i++) {
							this.sectionItems[i].editable = false;
						}
					}
					if (val == 1) {
						this.sectionItems = [];
						this.sectionItems = [{ slno: 0, name: "", editable: true }];
					}
					if (val == 99) {
						if (this.sectionItems.length != 0) {
							this.current_selection = "Section";
						} else {
							this.current_selection = "Step";
						}
					}
					if (this.sectionItems.length != 0) {
						if (this.current_selection == "Section") {
							this.sectionItems.forEach((els) => {
								els.form_questions_list.sort(
									(a, b) => a.serial_no - b.serial_no
								);
							});
							this.sectionItems.forEach((els) => {
								els.form_questions_list
									? els.form_questions_list.forEach((el) => {
											console.log(el, "el");
											if (el.dependant_question_available) {
												if (el.child_form_questions_list.length != 0) {
													el.dependent_inputType =
														el.child_form_questions_list[0].input_type_info.name;
													el.dependent_name =
														el.child_form_questions_list[0].name;
												}
											}
											el.expanded = false;
											el.type = el.input_type_info.name;
											el.default = false;
											el.editable_icon = false;
											el.showDropdown = false;
									  })
									: [];
							});

							let show_yes_no_boolean = true;
							for (let i = 0; i < this.sectionItems.length; i++) {
								for (
									let j = 0;
									j < this.sectionItems[i].form_questions_list.length;
									j++
								) {
									if (
										this.sectionItems[i].form_questions_list[j].input_type_info
											.name == "Yes / No"
									) {
										show_yes_no_boolean = false;
									}
								}
							}
							this.show_yes_no_boolean = show_yes_no_boolean;
						}
					}
					if (this.current_selection == "Step") {
						this.sectionItems = [];
						this.sectionItems.push({
							form_questions_list: JSON.parse(res.data).form_questions_list,
						});
						this.sectionItems.forEach((els) => {
							els.form_questions_list.sort((a, b) => a.serial_no - b.serial_no);
						});
						this.sectionItems.forEach((els) => {
							els.form_questions_list.forEach((el) => {
								if (el.dependant_question_available) {
									if (el.child_form_questions_list.length == 0) {
										el.expected_responses_list.forEach((eld) => {
											if (eld.dependent_form_question != null) {
												el.child_form_questions_list[0] =
													eld.dependent_form_question;
												el.dependent_inputType =
													eld.dependent_form_question.input_type_info.name;
												el.dependent_name = eld.dependent_form_question.name;
											}
										});
									} else {
										el.dependent_inputType =
											el.child_form_questions_list[0].input_type_info.name;
										el.dependent_name = el.child_form_questions_list[0].name;
									}
								}
								el.expanded = false;
								el.type = el.input_type_info.name;
								el.default = false;
								el.editable_icon = false;
								el.showDropdown = false;
							});
						});
						let show_yes_no_boolean = true;
						for (let i = 0; i < this.sectionItems.length; i++) {
							for (
								let j = 0;
								j < this.sectionItems[i].form_questions_list.length;
								j++
							) {
								if (
									this.sectionItems[i].form_questions_list[j].input_type_info
										.name == "Yes / No"
								) {
									show_yes_no_boolean = false;
								}
							}
						}
						this.show_yes_no_boolean = show_yes_no_boolean;
					}
					let serialNumberItems = [];
					for (let i = 0; i < this.sectionItems.length; i++) {
						for (
							let j = 0;
							j < this.sectionItems[i].form_questions_list.length;
							j++
						) {
							serialNumberItems.push({ name: j + 1, value: j + 1 });
						}
					}
					this.sectionItems.forEach((item) => {
						item.form_questions_list.forEach((question) => {
							if (question.type === "Timer") {
								const timerAttempts = question.timer_attempts || 0;
								question.stopwatches = [];
								question.isRunning = [];
								question.showStartButton = [];
								question.showResetButton = [];
								question.showStopButton = [];
								question.interval = [];
								for (let k = 0; k < timerAttempts; k++) {
									question.stopwatches.push({ time: 0, stopped: false });
									question.showStartButton.push(false);
									question.showResetButton.push(false);
									question.showStopButton.push(false);
									question.isRunning.push(false);
									question.interval.push(0);
								}
							}
						});
					});
					console.log(this.sectionItems, "this.sectionItems");
					this.serialNumberItems = serialNumberItems;
					this.formDialog = false;
					this.default = true;
					this.editformDialog = false;
					if (val == 99) {
						this.step = 2;
						this.isloading = false;
						this.$emit("click");
						this.current_view = "EDIT";
					}
					if (val == 2) this.sectionLoading = false;

					this.$forceUpdate();
				});
		},
		get_edit_question_values() {
			this.inputType = "";
			this.default = true;
			this.editformDialog = false;
		},
		edit_question(item) {
			this.storeObj = item;
			this.editformDialog = true;
		},
		get_list_forms() {
			this.$emit("show_form");
			this.current_view = "LIST";
		},
		get_preview_screen() {
			for (let i = 0; i < this.tabItems.length; i++) {
				this.tabItems[i].active = false;
			}
			this.tabItems[1].active = true;
			this.current_view = "ADD";
			this.step = 2;
			this.createProject = false;
		},
		get_launch_screen() {
			for (let i = 0; i < this.tabItems.length; i++) {
				this.tabItems[i].active = false;
			}
			this.tabItems[2].active = true;
			this.current_view = "ADD";
			this.step = 2;
			this.createProject = false;
			this.show_add_to_project = true;
		},
		get_form_screen() {
			for (let i = 0; i < this.tabItems.length; i++) {
				this.tabItems[i].active = false;
			}
			this.tabItems[0].active = true;
			this.current_view = "LIST";
			this.step = 1;
			this.createProject = false;
			this.show_add_to_project = false;
			this.$emit("show_form");
		},
		show_actions() {
			this.tabItems[0].active = true;
			this.tabItems[1].active = false;
			this.tabItems[2].active = false;
			this.step = 1;
			this.title = "";
			this.category = "";
			this.current_view = "ADD";
			this.scoringType = "";
			this.scoringType = "Not Applicable";
			this.current_selection = "";
			this.$validator.reset();
			this.$emit("click");
		},
		sellect_current_scoringType(scoringType) {
			let scoring = "";
			for (let i = 0; i < this.scoringType_items.length; i++) {
				if (this.scoringType_items[i].name == scoringType) {
					scoring = this.scoringType_items[i].name;
				}
			}
			this.scoringType = scoring;
		},
		get_input_type_data() {
			this.list_all_input_types();
			this.addEditInputDialog = false;
		},
		list_all_input_types() {
			this.inputTypeItems = [];
			formBuilderServices.listInputTypes().then((res) => {
				this.inputTypeItems = JSON.parse(res.data);
			});
		},
		delete_section_row(item, idx) {
			if (item.id) {
				let id = item.id;
				formBuilderServices.deleteSection(id).then((resp) => {
					// formBuilderServices.listSections(this.formDetails.id).then((res) => {
					// 	let results = JSON.parse(res.data);
					// 	let result_array = [];
					// 	for (let i = 0; i < results.length; i++) {
					// 		if (results[i].form == this.formDetails.id) {
					// 			result_array.push(results[i]);
					// 		}
					// 	}
					// 	this.sectionItems = result_array;
					// });
					this.call_form_list_api();
				});
			} else {
				this.sectionItems.splice(idx, 1);
				for (let i = 0; i < this.sectionItems.length; i++) {
					this.sectionItems[i].slno = i;
				}
				this.$forceUpdate();
			}
		},
		save_section_changes(idx, item) {
			this.sectionItems = this.sectionItems.filter((el) => el.name != "");
			let edit_params = [];
			let add_params = [];
			var call_add_api = false;
			for (let i = 0; i < this.sectionItems.length; i++) {
				if (this.sectionItems[i].id) {
					edit_params.push({
						name: this.sectionItems[i].name,
						form: this.formDetails.id,
						serial_no: this.sectionItems[i].serial_no,
						id: this.sectionItems[i].id,
					});
				} else {
					add_params.push({
						name: this.sectionItems[i].name,
						form: this.formDetails.id,
						serial_no: i + 1,
					});
					call_add_api = true;
				}
			}
			formBuilderServices.editSection(edit_params).then((resp) => {
				console.log(resp, "res add sec");
			});
			if (call_add_api == true) {
				formBuilderServices.addSection(add_params).then((resp) => {
					console.log(resp, "res add sec");
				});
			}
			setTimeout(() => {
				this.call_form_list_api(2);
			}, 200);
		},
		async get_category_data() {
			await this.list_all_categories();
			this.addEditDialog = false;
			this.category = "";
		},
		create_project_condition() {
			this.storeObj.action = "ADD";
			this.createProject = true;
			this.current_view = "";
		},
		edit_form_api() {
			let params = {
				name: this.title,
				form_category: this.category_obj.id,
				serial_no: this.category_obj.serial_no,
				description: "",
				total_points: 0,
				// is_critical: this.markCritical,
				scoring_type:
					this.scoringType == "Not Applicable"
						? "not_applicable"
						: this.scoringType == "Score for overall form"
						? "all_pass"
						: this.scoringType == "Score for each step"
						? "by_steps"
						: "",
				show_mark_all_yes_no: this.show_mark_all_yes_no,
				show_mark_all_na: this.show_mark_all_na,
			};
			let id = this.formDetails.id;
			formBuilderServices.editForm(id, params).then((res) => {
				this.formDetails = JSON.parse(res.data);
				if (this.scoringType == "Score for overall form") {
					if (this.formListResponse.expected_responses_list.length != 0) {
						this.edit_expected_response_api();
					} else {
						this.expected_response_api();
					}
				} else {
					this.formEditable = false;
				}
			});
		},
		add_form_api() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					let params = {
						name: this.title,
						form_category: this.category_obj.id,
						serial_no: this.category_obj.serial_no,
						description: "",
						total_points: 0,
						// is_critical: this.markCritical,
						scoring_type:
							this.scoringType == "Not Applicable"
								? "not_applicable"
								: this.scoringType == "Score for overall form"
								? "all_pass"
								: this.scoringType == "Score for each step"
								? "by_steps"
								: "",
						show_mark_all_yes_no: false,
						show_mark_all_na: true,
					};
					formBuilderServices.addForm(params).then((res) => {
						this.formDetails = JSON.parse(res.data);
						if (this.scoringType == "Score for overall form") {
							this.expected_response_api();
						} else {
							if (this.step_selected == 2) this.step = 2;
							if (this.step_selected == 4) this.step = 2;
							this.$forceUpdate();
						}
					});
				} else {
					alert("Enter required fields");
				}
			});
		},
		edit_expected_response_api() {
			let params = {
				question: null,
				form: this.formDetails.id,
				input_boolean_value: true,
				input_number_value: 0,
				input_text_value: "",
				selected_input_option: "",
				selected_input_options: [],
				expected_boolean_value: this.yes_value == "All Pass" ? true : false,
				expected_number_value: 0,
				expected_text_value: "",
				expected_input_option: "",
				expected_input_options: [],
				expected_range_minimum: 0,
				expected_range_maximum: 0,
				applicable_on: "form",
				comparison_types: "equals_to",
				status_on_trigger: "pass",
				points_on_trigger:
					this.pos_neg == "negative"
						? "-" + this.yes_value_points
						: this.yes_value_points,
				serial_no: 1,
			};
			let params_no = {
				question: null,
				form: this.formDetails.id,
				input_boolean_value: true,
				input_number_value: 0,
				input_text_value: "",
				selected_input_option: "",
				selected_input_options: [],
				expected_boolean_value: this.no_value == "All Pass" ? true : false,
				expected_number_value: 0,
				expected_text_value: "",
				expected_input_option: "",
				expected_input_options: [],
				expected_range_minimum: 0,
				expected_range_maximum: 0,
				applicable_on: "form",
				comparison_types: "equals_to",
				status_on_trigger: "fail",
				points_on_trigger:
					this.pos_neg_2 == "negative"
						? "-" + this.no_value_points
						: this.no_value_points,
				serial_no: 2,
			};
			for (let i = 0; i < 2; i++) {
				if (i == 0) {
					formBuilderServices
						.editExpectedResponse(
							this.current_view == "EDIT"
								? this.formListResponse.expected_responses_list[0].id
								: this.expectedResponse_Id1,
							params
						)
						.then((res) => {
							this.expectedResponse_Id1 = JSON.parse(res.data).id;
						});
				}
				if (i == 1) {
					formBuilderServices
						.editExpectedResponse(
							this.current_view == "EDIT"
								? this.formListResponse.expected_responses_list[1].id
								: this.expectedResponse_Id2,
							params_no
						)
						.then((res) => {
							this.expectedResponse_Id2 = JSON.parse(res.data).id;
							this.formEditable = false;
						});
				}
			}
		},
		expected_response_api() {
			let params = {
				question: null,
				form: this.formDetails.id,
				input_boolean_value: this.yes_value == "All Pass" ? true : false,
				input_number_value: 0,
				input_text_value: "",
				selected_input_option: "",
				selected_input_options: [],
				expected_boolean_value: this.yes_value == "All Pass" ? true : false,
				expected_number_value: 0,
				expected_text_value: "",
				expected_input_option: "",
				expected_input_options: [],
				expected_range_minimum: 0,
				expected_range_maximum: 0,
				applicable_on: "form",
				comparison_types: "equals_to",
				status_on_trigger: "pass",
				points_on_trigger:
					this.pos_neg == "negative"
						? "-" + this.yes_value_points
						: this.yes_value_points,
				serial_no: 1,
			};
			let params_no = {
				question: null,
				form: this.formDetails.id,
				input_boolean_value: this.no_value == "All Pass" ? true : true,
				input_number_value: 0,
				input_text_value: "",
				selected_input_option: "",
				selected_input_options: [],
				expected_boolean_value: this.no_value == "All Pass" ? true : false,
				expected_number_value: 0,
				expected_text_value: "",
				expected_input_option: "",
				expected_input_options: [],
				expected_range_minimum: 0,
				expected_range_maximum: 0,
				applicable_on: "form",
				comparison_types: "equals_to",
				status_on_trigger: "fail",
				points_on_trigger:
					this.pos_neg_2 == "negative"
						? "-" + this.no_value_points
						: this.no_value_points,
				serial_no: 2,
			};
			for (let i = 0; i < 2; i++) {
				if (i == 0) {
					formBuilderServices.addExpectedResponse(params).then((res) => {
						this.expectedResponse_Id1 = JSON.parse(res.data).id;
					});
				}
				if (i == 1) {
					formBuilderServices.addExpectedResponse(params_no).then((res) => {
						this.expectedResponse_Id2 = JSON.parse(res.data).id;
						if (this.step_selected == 2) this.step = 2;
						if (this.step_selected == 4) this.step = 2;
						this.formEditable = false;
						this.$forceUpdate();
					});
				}
			}
		},
		proceed_further(step) {
			this.step_selected = step;
			if (step == 2) this.current_selection = "Section";
			if (step == 4) this.current_selection = "Step";
			if (this.current_selection == "") {
				alert(
					"Select between Add New Section and Add New Step to proceed further"
				);
			} else {
				this.add_form_api();
			}
		},
		delete_api_toggle(item) {
			if (this.deleteItemName == "Form") {
				this.toggle_actions(null, item, "DELETE_API_FORM");
			}
			if (this.deleteItemName == "Question") {
				this.toggle_actions(null, item, "DELETE_API_QUESTION");
			}
		},
		delete_form_row(item) {
			this.deleteItemName = "Question";
			this.deleteDialog = true;
			this.confirmationObject = item;
			this.confirmationTitle = `Are you sure to delete the question ${item.name}`;
		},
		toggle_actions(idx, item, type) {
			switch (type) {
				case "DELETE":
					this.deleteItemName = "Form";
					this.deleteDialog = true;
					this.confirmationObject = item;
					this.confirmationTitle = `Are you sure to delete the form ${item.name}`;
					break;
				case "EDIT":
					this.isloading = true;
					this.list_form_details(item.form_category, item.id);
					break;
				case "DELETE_API_FORM":
					formBuilderServices.deleteForm(item.id).then((res) => {
						this.list_forms();
						this.deleteDialog = false;
					});
					break;
				case "DELETE_API_QUESTION":
					console.log("coming here", item);

					formBuilderServices.deleteQuestion(item.id).then((res) => {
						console.log(res, "res");

						this.call_form_list_api();
						this.deleteDialog = false;
					});
					break;
				default:
					break;
			}
		},
		list_form_details(category, id) {
			this.isloading = true;
			formBuilderServices.listFormsByCategoryId(category).then((res) => {
				let resp = JSON.parse(res.data);
				let form = {};
				for (let i = 0; i < resp.length; i++) {
					if (resp[i].id == id) {
						form = resp[i];
					}
				}
				this.title = form.name;
				let category = "";
				for (let i = 0; i < this.category_items.length; i++) {
					if (this.category_items[i].id == form.form_category) {
						category = this.category_items[i].name;
					}
				}
				this.category = category;
				let scoringType = "";
				for (let i = 0; i < this.scoringType_items.length; i++) {
					if (this.scoringType_items[i].value == form.scoring_type) {
						scoringType = this.scoringType_items[i].name;
					}
				}
				this.scoringType = scoringType;
				// this.is_critical = form.is_critical;
				this.formDetails = form;
				this.call_form_list_api(99);
			});
		},
		list_forms() {
			this.formLists = [];
			this.isloading = true;
			formBuilderServices
				.listTasks()
				.then((res) => {
					this.formLists = JSON.parse(res.data);
					for (let i = 0; i < this.formLists.length; i++) {
						for (let j = 0; j < this.category_items_new.length; j++) {
							if (
								this.formLists[i].form_category == this.category_items_new[j].id
							) {
								this.formLists[i].category = this.category_items_new[j].name;
							}
						}
					}
					this.isloading = false;
				})
				.catch(() => {
					this.isloading = false;
				});
		},
		delete_category(category) {
			this.category = "";
			formBuilderServices.deleteCategory(category.id).then((res) => {
				this.list_all_categories();
			});
		},
		sellect_current_category(category) {
			for (let i = 0; i < this.category_items.length; i++) {
				if (
					this.category_items[i].name.trim().toLowerCase() ==
					category.trim().toLowerCase()
				) {
					this.category_obj = this.category_items[i];
				}
			}
		},
		add_edit_input_type(type, item) {
			this.storeObj = {};
			switch (type) {
				case "ADD":
					this.storeObj.type = type;
					this.addEditInputDialog = true;
					break;
				case "EDIT":
					this.storeObj = item;
					this.storeObj.type = type;
					this.addEditInputDialog = true;
					break;

				default:
					break;
			}
		},
		add_edit_category(type, item) {
			this.category = "";
			this.storeObj = {};
			switch (type) {
				case "ADD":
					this.storeObj.type = type;
					this.addEditDialog = true;
					break;
				case "EDIT":
					this.storeObj = item;
					this.storeObj.type = type;
					this.addEditDialog = true;
					break;

				default:
					break;
			}
		},
		list_all_categories() {
			formBuilderServices.listAllCategory().then((res) => {
				this.category_items = JSON.parse(res.data);
				this.category_items_new = JSON.parse(res.data);
			});
		},
		collapse_item(item) {
			item.expanded = !item.expanded;
			this.$forceUpdate();
			return item;
		},
		expand_item(item) {
			item.expanded = !item.expanded;
			this.$forceUpdate();
			return item;
		},
		show_form_card(idx, item) {
			console.log(item, this.formItemArray, "this.formItemArray");
			this.storeObj = {};
			this.storeObj.selectedStepItem = item;
			this.storeObj.formDetails = this.formDetails;
			this.storeObj.serial_no = item.form_questions_list.length + 1;
			this.formDialog = true;
			this.$forceUpdate();
		},
		addToFormArrayCondition() {
			this.inputType = "";
			this.default = true;
			this.formDialog = false;
		},
		get_image(arr) {
			arr.forEach(async (el) => {
				let params = {
					file_path: el.file_path,
					storage: "task",
				};
				await formBuilderServices.getAttachmentURL(params).then((res) => {
					el.src = JSON.parse(res.data).data;
				});
			});
			this.imagesArray = arr;
			setTimeout(() => {
				this.viewQuestionImagesDialog = true;
			}, 200);
			this.$forceUpdate();
		},
		addToFormArray(val) {
			this.call_form_list_api(4);
			this.preview_formItemArray = [];
			this.formItemArray = [];
			if (val == 1) {
				this.step += 1;
			}
		},
		open_step_input_dialog(idx, item) {
			this.storeObj = {};
			let storeObj = {};
			for (let i = 0; i < this.inputTypeItems.length; i++) {
				if (this.inputTypeItems[i].name.toLowerCase() == item.toLowerCase()) {
					storeObj = this.inputTypeItems[i];
				}
			}
			this.storeObj = storeObj;
			this.formItemArray.splice(-1);
			this.storeObj.selectedStepItem = this.selectedStepItem;
			this.storeObj.formDetails = this.formDetails;
			this.storeObj.serial_no = this.formItemArray.length + 1;
			this.formDialog = true;
		},
		addStep(idx, item) {
			this.sectionLoading = true;
			let error = false;
			if (item.name == "") {
				error = true;
			}
			if (error == false) {
				this.save_section_changes(idx, item);
			} else {
				this.sectionLoading = false;

				alert("Enter Section Name to Continue");
			}
		},
		goToPreview(value) {
			if (value == 1) {
				this.active_view = "WEB";
				this.preview_formItemArray = [];
				formBuilderServices
					.listQuestion(this.formDetails.id)
					.then(async (res) => {
						let response = JSON.parse(res.data);
						if (this.current_selection == "Section") {
							let sections = response.sections_list;
							this.preview_formItemArray = sections;
							this.preview_formItemArray.forEach((el) => {
								el.form_questions_list.forEach((el1) => {
									el1.expanded = false;
								});
							});
							setTimeout(() => {
								this.tabItems[value].active = true;
								this.tabItems[value - 1].active = false;
							}, 100);
						}
						if (this.current_selection == "Step") {
							let sections = response;
							this.preview_formItemArray = new Array(sections);
							this.preview_formItemArray.forEach((el) => {
								el.form_questions_list.forEach((el1) => {
									el1.expanded = false;
								});
							});
							setTimeout(() => {
								this.tabItems[value].active = true;
								this.tabItems[value - 1].active = false;
							}, 100);
						}
					});
			}
			if (value == 2) {
				this.tabItems[value].active = true;
				this.tabItems[value - 1].active = false;
				this.tabItems[value - 2].active = false;
			}
		},
		goToprevious_tab() {
			for (let i = 0; i < this.tabItems.length; i++) {
				this.tabItems[i].active = false;
			}
			this.tabItems[0].active = true;

			// this.step = 4;
		},
		nextStep(value) {
			if (value == 2) {
				if (this.sectionItems.length != 0) {
					this.sectionItems = this.sectionItems.filter(
						(el) => el.section_name != ""
					);
					let params = [];
					for (let i = 0; i < this.sectionItems.length; i++) {
						params.push({
							name: this.sectionItems[i].section_name,
							form: this.formDetails.id,
							serial_no: i + 1,
						});
					}
					formBuilderServices.addSection(params).then((resp) => {
						formBuilderServices
							.listSections(this.formDetails.id)
							.then((res) => {
								let results = JSON.parse(res.data);
								let result_array = [];
								for (let i = 0; i < results.length; i++) {
									if (results[i].form == this.formDetails.id) {
										result_array.push(results[i]);
									}
								}
								this.sectionItems = result_array;
								this.step = 2;
							});
					});
				} else {
					alert("Section cannot be empty");
				}
			}
		},
		prevStep(val) {
			if (val == 99) {
				if (this.current_selection == "Section") {
					this.step -= 1;
				} else {
					this.step = 1;
				}
			} else {
				this.step -= 1;
			}
		},
		addNewSection(val) {
			if (val == 1) {
				if (!this.sectionItems[this.sectionItems.length - 1].editable) {
					this.sectionItems.push({
						name: "",
						serial_no: this.sectionItems.length + 1,
						editable: true,
					});
				}
				console.log(document, "document");
				setTimeout(() => {
					const cardElement = document.getElementById("scrollableCard");
					cardElement.scrollTop = cardElement.scrollHeight;
				}, 100);
			}
			if (val == 2) {
				this.step -= 1;
			}
		},
	},
};
</script>
<style lang="scss">
.v2-forms {
	font-size: 14px;
	background-color: #f6f7f9;
	width: 100%;
	overflow-x: hidden;
	margin: auto;
	.form-lists {
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;
		.el-table th.el-table__cell > .cell {
			text-align: left !important;
			color: #333333 !important;
			text-transform: none !important;
		}
		tbody tr td {
			text-align: left !important;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: 1px solid #ebeef5;
			font-size: 13px;
			text-align: left !important;
		}
		.el-table__body-wrapper {
			text-align: left !important;
			overflow-y: auto;
			min-height: 58vh;
			max-height: 58vh;
		}
	}
}

.active-view {
	border: 1px solid;
	border-color: #d26300;
}
.list:hover {
	background-color: #f9f9f9;
	cursor: pointer;
}
.button-class-white {
	height: 40px;
	background: #ffffff;
	border-radius: 12px;
	color: #d26300;
	border: 1px solid #d26300;
}
.button-class-white2 {
	height: 40px;
	background: #ffffff;
	border-radius: 12px;
	color: #d26300;
	border: 1px solid #d26300;
}
.input-class-select {
	background: #ffffff;
	border-radius: 12px;
	padding-left: 5px;
	height: 40px;
	width: 100%;
	background-position: -webkit-calc(100% - 20px) center;
	-webkit-transition: 0.5s;
	transition: 0.5s;
}
.input-class-select2 {
	background: #ffffff;
	border-radius: 12px;
	padding-left: 5px;
	height: 40px;
	width: 100%;
	background-position: -webkit-calc(100% - 20px) center;
	-webkit-transition: 0.5s;
	transition: 0.5s;
}
.input-class .el-input__inner {
	background: #ffffff;
	border-radius: 12px;
	padding-left: 10px;
	height: 40px;
	width: 100%;
	background-position: -webkit-calc(100% - 20px) center;
	-webkit-transition: 0.5s;
	transition: 0.5s;
	font-size: 12px;
}
.button-class-no-text {
	position: absolute;
	height: 40px;
	background: #ffffff;
	border-radius: 12px;
	color: black;
}
.button-class {
	position: absolute;
	height: 40px;
	background: #d26300;
	border-radius: 12px;
	color: #ffffff;
}
.searchicon {
	padding-left: 20px;
	height: 40px;
	border-radius: 12px;
	border: none;
	width: 100%;

	background: #ffffff
		url("https://static.thenounproject.com/png/101791-200.png") no-repeat;
	background-size: 15px;
	background-position: -webkit-calc(100% - 20px) center;
	-webkit-transition: 0.5s;
	transition: 0.5s;
	outline: none;
}
body {
	background: #e2e2e2;
}
.el-select.select {
	border-radius: 12px !important;
	font-size: 12px;
	width: 100%;
}
.el-select.select .el-input {
	border-radius: 12px !important;
	width: 100%;
	font-size: 12px;
}
.el-select.select .el-input .el-input__inner {
	border-radius: 12px !important;
	width: 100%;
	font-size: 12px;
	padding-left: 20px;
}
.el-select.select1 .el-input .el-input__inner {
	border-radius: 12px !important;
	width: 100%;
	border-color: #d26300;
	max-height: 30px;
	font-size: 12px;
	padding-left: 20px;
}
.el-select.select1 .el-input .el-select__caret {
	margin-top: 6px;
	font-size: 12px;
}
.date .el-input__inner {
	border-radius: 12px;
}
.stopwatch-container {
	display: flex;
	justify-content: left;
	align-items: center;
	margin-bottom: 15px;
}
.total-average-container {
	display: block;
	margin-top: 10px;
}
.time-index {
	font-size: 14px;
	margin-right: 10px;
}
.stopwatch {
	font-size: 14px;
	margin-right: 20px;
	margin-left: 100px;
}
.controls button {
	margin-right: 10px;
}
</style>
